// var shipProtections = [
//   { id: 47647782961378, min: '0.01', max: '38.99', price: '0.98' },
//   { id: 47648691814626, min: '39.00', max: '51.99', price: '1.15' },
//   { id: 47648698433762, min: '52.00', max: '63.99', price: '1.35' },
//   { id: 47648698532066, min: '64.00', max: '75.99', price: '1.55' }
// ];


var shipProtections = (function () {
  var result = [];
  // 每一行代表一个区间配置：[min, max, price, id]
  var data = [
    [0.01, 38.99, 0.98, 7782961378],
    [39.00, 51.99, 1.15, 8691814626],
    [52.00, 63.99, 1.45, 8698433762],
    [64.00, 75.99, 1.75, 8698532066],
    [76.00, 87.99, 2.05, 8698564834],
    [88.00, 99.99, 2.35, 8698630370],
    [100.00, 111.99, 2.65, 8698728674],
    [112.00, 123.99, 2.95, 8698761442],
    [124.00, 135.99, 3.25, 8698826978],
    [136.00, 147.99, 3.55, 8698892514],
    [148.00, 159.99, 3.85, 8698925282],
    [160.00, 171.99, 4.15, 8699154658],
    [172.00, 183.99, 4.45, 8699252962],
    [184.00, 195.99, 4.75, 8699318498],
    [196.00, 207.99, 5.05, 8699384034],
    [208.00, 219.99, 5.35, 8699449570],
    [220.00, 231.99, 5.65, 8699482338],
    [232.00, 243.99, 5.95, 8699547874],
    [244.00, 255.99, 6.25, 8699580642],
    [256.00, 267.99, 6.55, 8699646178],
    [268.00, 279.99, 6.85, 8699678946],
    [280.00, 291.99, 7.15, 8699711714],
    [292.00, 303.99, 7.45, 8699777250],
    [304.00, 315.99, 7.75, 8699842786],
    [316.00, 327.99, 8.05, 8699908322],
    [328.00, 339.99, 8.35, 8699973858],
    [340.00, 351.99, 8.65, 8700039394],
    [352.00, 363.99, 8.95, 8700104930],
    [364.00, 375.99, 9.25, 8700170466],
    [376.00, 387.99, 9.55, 8700236002],
    [388.00, 399.99, 9.85, 8700301538],
    [400.00, 411.99, 10.15, 8700334306],
    [412.00, 423.99, 10.45, 8700432610],
    [424.00, 435.99, 10.75, 8700498146],
    [436.00, 447.99, 11.05, 8700563682],
    [448.00, 459.99, 11.35, 8700596450],
    [460.00, 471.99, 11.65, 8700694754],
    [472.00, 483.99, 11.95, 8700760290],
    [484.00, 495.99, 12.25, 8700825826],
    [496.00, 507.99, 12.55, 8700891362],
    [508.00, 519.99, 12.85, 8700956898],
    [520.00, 531.99, 13.15, 8700989666],
    [532.00, 543.99, 13.45, 8701087970],
    [544.00, 555.99, 13.75, 8701120738],
    [556.00, 567.99, 14.05, 8701186274],
    [568.00, 579.99, 14.35, 8701251810],
    [580.00, 591.99, 14.65, 8701317346],
    [592.00, 603.99, 14.95, 8701382882],
    [604.00, 615.99, 15.25, 8701415650],
    [616.00, 627.99, 15.55, 8701481186],
    [628.00, 639.99, 15.85, 8701546722],
    [640.00, 651.99, 16.15, 8701612258],
    [652.00, 663.99, 16.45, 8701677794],
    [664.00, 675.99, 16.75, 8701710562],
    [676.00, 687.99, 17.05, 8701776098],
    [688.00, 699.99, 17.35, 8701841634],
    [700.00, 711.99, 17.65, 8701907170],
    [712.00, 723.99, 17.95, 8702005474],
    [724.00, 735.99, 18.25, 8702071010],
    [736.00, 747.99, 18.55, 8702136546],
    [748.00, 759.99, 18.85, 8702202082],
    [760.00, 771.99, 19.15, 8702234850],
    [772.00, 783.99, 19.45, 8702300386],
    [784.00, 795.99, 19.75, 8702365922],
    [796.00, 807.99, 20.05, 8702431458],
    [808.00, 819.99, 20.35, 8702464226],
    [820.00, 831.99, 20.65, 8702529762],
    [832.00, 843.99, 20.95, 8702595298],
    [844.00, 855.99, 21.25, 8702628066],
    [856.00, 867.99, 21.55, 8702693602],
    [868.00, 879.99, 21.85, 8702759138],
    [880.00, 891.99, 22.15, 8702791906],
    [892.00, 903.99, 22.45, 8702857442],
    [904.00, 915.99, 22.75, 8702922978],
    [916.00, 927.99, 23.05, 8702988514],
    [928.00, 939.99, 23.35, 8703021282],
    [940.00, 951.99, 23.65, 8703086818],
    [952.00, 963.99, 23.95, 8703152354],
    [964.00, 975.99, 24.25, 8703185122],
    [976.00, 987.99, 24.55, 8703250658],
    [988.00, 999.99, 24.85, 8703316194],
    [1000.00, 1011.99, 25.15, 8703414498],
    [1012.00, 1023.99, 25.45, 8703447266],
    [1024.00, 1035.99, 25.75, 8703512802],
    [1036.00, 1047.99, 26.05, 8703578338],
    [1048.00, 1059.99, 26.35, 8703643874],
    [1060.00, 1071.99, 26.65, 8703709410],
    [1072.00, 1083.99, 26.95, 8703742178],
    [1084.00, 1095.99, 27.25, 8703807714],
    [1096.00, 1107.99, 27.55, 8703873250],
    [1108.00, 1119.99, 27.85, 8703938786],
    [1120.00, 1131.99, 28.15, 8703971554],
    [1132.00, 1143.99, 28.45, 8704037090],
    [1144.00, 1155.99, 28.75, 8704102626],
    [1156.00, 1167.99, 29.05, 8704168162],
    [1168.00, 1179.99, 29.35, 8704200930],
    [1180.00, 1191.99, 29.65, 8704266466],
    [1192.00, 1203.99, 29.95, 8704332002],
    [1204.00, 1215.99, 30.25, 8704364770],
    [1216.00, 1227.99, 30.55, 8704430306],
    [1228.00, 1239.99, 30.85, 8704495842],
    [1240.00, 1251.99, 31.15, 8704561378],
    [1252.00, 1263.99, 31.45, 8704626914],
    [1264.00, 1275.99, 31.75, 8704692450],
    [1276.00, 1287.99, 32.05, 8704757986],
    [1288.00, 1299.99, 32.35, 8704823522],
    [1300.00, 1311.99, 32.65, 8704856290],
    [1312.00, 1323.99, 32.95, 8704921826],
    [1324.00, 1335.99, 33.25, 8705020130],
    [1336.00, 1347.99, 33.55, 8705085666],
    [1348.00, 1359.99, 33.85, 8705151202],
    [1360.00, 1371.99, 34.15, 8705183970],
    [1372.00, 1383.99, 34.45, 8705249506],
    [1384.00, 1395.99, 34.75, 8705315042],
    [1396.00, 1407.99, 35.05, 8705380578],
    [1408.00, 1419.99, 35.35, 8705446114],
    [1420.00, 1431.99, 35.65, 8705511650],
    [1432.00, 1443.99, 35.95, 8705544418],
    [1444.00, 1455.99, 36.25, 8705609954],
    [1456.00, 1467.99, 36.55, 8705708258],
    [1468.00, 1479.99, 36.85, 8705773794],
    [1480.00, 1491.99, 37.15, 8705839330],
    [1492.00, 1503.99, 37.45, 8705872098],
    [1504.00, 1515.99, 37.75, 8705937634],
    [1516.00, 1527.99, 38.05, 8706003170],
    [1528.00, 1539.99, 38.35, 8706035938],
    [1540.00, 1551.99, 38.65, 8706101474],
    [1552.00, 1563.99, 38.95, 8706167010],
    [1564.00, 1575.99, 39.25, 8706232546],
    [1576.00, 1587.99, 39.55, 8706298082],
    [1588.00, 1599.99, 39.85, 8706330850],
    [1600.00, 1611.99, 40.15, 8706396386],
    [1612.00, 1623.99, 40.45, 8706461922],
    [1624.00, 1635.99, 40.75, 8706527458],
    [1636.00, 1647.99, 41.05, 8706560226],
    [1648.00, 1659.99, 41.35, 8706592994],
    [1660.00, 1671.99, 41.65, 8706658530],
    [1672.00, 1683.99, 41.95, 8706724066],
    [1684.00, 1695.99, 42.25, 8706789602],
    [1696.00, 1707.99, 42.55, 8706822370],
    [1708.00, 1719.99, 42.85, 8706887906],
    [1720.00, 1731.99, 43.15, 8706953442],
    [1732.00, 1743.99, 43.45, 8707018978],
    [1744.00, 1755.99, 43.75, 8707084514],
    [1756.00, 1767.99, 44.05, 8707117282],
    [1768.00, 1779.99, 44.35, 8707182818],
    [1780.00, 1791.99, 44.65, 8707248354],
    [1792.00, 1803.99, 44.95, 8707313890],
    [1804.00, 1815.99, 45.25, 8707379426],
    [1816.00, 1827.99, 45.55, 8707412194],
    [1828.00, 1839.99, 45.85, 8707477730],
    [1840.00, 1851.99, 46.15, 8707543266],
    [1852.00, 1863.99, 46.45, 8707608802],
    [1864.00, 1875.99, 46.75, 8707674338],
    [1876.00, 1887.99, 47.05, 8707739874],
    [1888.00, 1899.99, 47.35, 8707772642],
    [1900.00, 1911.99, 47.65, 8707838178],
    [1912.00, 1923.99, 47.95, 8707903714],
    [1924.00, 1935.99, 48.25, 8707969250],
    [1936.00, 1947.99, 48.55, 8708034786],
    [1948.00, 1959.99, 48.85, 8708100322],
    [1960.00, 1971.99, 49.15, 8708133090],
    [1972.00, 1983.99, 49.45, 8708198626],
    [1984.00, 1995.99, 49.75, 8708264162],
    [1996.00, 2007.99, 50.05, 8708296930],
    [2008.00, 2019.99, 50.35, 8708362466],
    [2020.00, 2031.99, 50.65, 8708428002],
    [2032.00, 2043.99, 50.95, 8708460770],
    [2044.00, 2055.99, 51.25, 8708526306],
    [2056.00, 2067.99, 51.55, 8708559074],
    [2068.00, 2079.99, 51.85, 8708624610],
    [2080.00, 2091.99, 52.15, 8708821218],
    [2092.00, 2103.99, 52.45, 8708886754],
    [2104.00, 2115.99, 52.75, 8708985058],
    [2116.00, 2127.99, 53.05, 8728350946],
    [2128.00, 2139.99, 53.35, 8728416482],
    [2140.00, 2151.99, 53.65, 8728449250],
    [2152.00, 2163.99, 53.95, 8728514786],
    [2164.00, 2175.99, 54.25, 8728580322],
    [2176.00, 2187.99, 54.55, 8728645858],
    [2188.00, 2199.99, 54.85, 8728776930],
    [2200.00, 2211.99, 55.15, 8728809698],
    [2212.00, 2223.99, 55.45, 8728908002],
    [2224.00, 2235.99, 55.75, 8729006306],
    [2236.00, 2247.99, 56.05, 8729071842],
    [2248.00, 2259.99, 56.35, 8729170146],
    [2260.00, 2271.99, 56.65, 8729268450],
    [2272.00, 2283.99, 56.95, 8729366754],
    [2284.00, 2295.99, 57.25, 8729399522],
    [2296.00, 2307.99, 57.55, 8729465058],
    [2308.00, 2319.99, 57.85, 8729530594],
    [2320.00, 2331.99, 58.15, 8729596130],
    [2332.00, 2343.99, 58.45, 8729661666],
    [2344.00, 2355.99, 58.75, 8729727202],
    [2356.00, 2367.99, 59.05, 8729792738],
    [2368.00, 2379.99, 59.35, 8729825506],
    [2380.00, 2391.99, 59.65, 8729891042],
    [2392.00, 2403.99, 59.95, 8729956578],
    [2404.00, 2415.99, 60.25, 8730022114],
    [2416.00, 2427.99, 60.55, 8730054882],
    [2428.00, 2439.99, 60.85, 8730120418],
    [2440.00, 2451.99, 61.15, 8730185954],
    [2452.00, 2463.99, 61.45, 8730251490],
    [2464.00, 2475.99, 61.75, 8730317026],
    [2476.00, 2487.99, 62.05, 8730382562],
    [2488.00, 2499.99, 62.35, 8730448098],
    [2500.00, 2511.99, 62.65, 8730480866],
    [2512.00, 2523.99, 62.95, 8730546402],
    [2524.00, 2535.99, 63.25, 8730611938],
    [2536.00, 2547.99, 63.55, 8730677474],
    [2548.00, 2559.99, 63.85, 8730743010],
    [2560.00, 2571.99, 64.15, 8730808546],
    [2572.00, 2583.99, 64.45, 8730841314],
    [2584.00, 2595.99, 64.75, 8730939618],
    [2596.00, 2607.99, 65.05, 8731037922],
    [2608.00, 2619.99, 65.35, 8731365602],
    [2620.00, 2631.99, 65.65, 8731431138],
    [2632.00, 2643.99, 65.95, 8731463906],
    [2644.00, 2655.99, 66.25, 8731594978],
    [2656.00, 2667.99, 66.55, 8731660514],
    [2668.00, 2679.99, 66.85, 8731726050],
    [2680.00, 2691.99, 67.15, 8731791586],
    [2692.00, 2703.99, 67.45, 8731857122],
    [2704.00, 2715.99, 67.75, 8731889890],
    [2716.00, 2727.99, 68.05, 8732053730],
    [2728.00, 2739.99, 68.35, 8732152034],
    [2740.00, 2751.99, 68.65, 8732184802],
    [2752.00, 2763.99, 68.95, 8732250338],
    [2764.00, 2775.99, 69.25, 8732315874],
    [2776.00, 2787.99, 69.55, 8732381410],
    [2788.00, 2799.99, 69.85, 8732414178],
    [2800.00, 2811.99, 70.15, 8732479714],
    [2812.00, 2823.99, 70.45, 8732545250],
    [2824.00, 2835.99, 70.75, 8732578018],
    [2836.00, 2847.99, 71.05, 8732643554],
    [2848.00, 2859.99, 71.35, 8732709090],
    [2860.00, 2871.99, 71.65, 8732774626],
    [2872.00, 2883.99, 71.95, 8732807394],
    [2884.00, 2895.99, 72.25, 8732872930],
    [2896.00, 2907.99, 72.55, 8732938466],
    [2908.00, 2919.99, 72.85, 8733004002],
    [2920.00, 2931.99, 73.15, 8733069538],
    [2932.00, 2943.99, 73.45, 8733135074],
    [2944.00, 2955.99, 73.75, 8733167842],
    [2956.00, 2967.99, 74.05, 8733233378],
    [2968.00, 2979.99, 74.35, 8733266146],
    [2980.00, 2991.99, 74.65, 8733331682],
    [2992.00, 3003.99, 74.95, 8733397218],
    [3004.00, 3015.99, 75.25, 8733462754],
    [3016.00, 3027.99, 75.55, 8733528290],
    [3028.00, 3039.99, 75.85, 8733593826],
    [3040.00, 3051.99, 76.15, 8733659362],
    [3052.00, 3063.99, 76.45, 8733692130],
    [3064.00, 3075.99, 76.75, 8733757666],
    [3076.00, 3087.99, 77.05, 8733823202],
    [3088.00, 3099.99, 77.35, 8733888738],
    [3100.00, 3111.99, 77.65, 8733954274],
    [3112.00, 3123.99, 77.95, 8734019810],
    [3124.00, 3135.99, 78.25, 8734085346],
    [3136.00, 3147.99, 78.55, 8734150882],
    [3148.00, 3159.99, 78.85, 8734216418],
    [3160.00, 3171.99, 79.15, 8734281954],
    [3172.00, 3183.99, 79.45, 8734347490],
    [3184.00, 3195.99, 79.75, 8734413026],
    [3196.00, 2007.99, 80.05, 8734445794],
    [3208.00, 3219.99, 80.35, 8734511330],
    [3220.00, 3231.99, 80.65, 8734773474],
    [3232.00, 3243.99, 80.95, 8734806242],
    [3244.00, 3255.99, 81.25, 8734871778],
    [3256.00, 3267.99, 81.55, 8734904546],
    [3268.00, 3279.99, 81.85, 8734937314],
    [3280.00, 3291.99, 82.15, 8735002850],
    [3292.00, 3303.99, 82.45, 8735068386],
    [3304.00, 3315.99, 82.75, 8735133922],
    [3316.00, 3327.99, 83.05, 8735199458],
    [3328.00, 3339.99, 83.35, 8735232226],
    [3340.00, 3351.99, 83.65, 8735297762],
    [3352.00, 3363.99, 83.95, 8735363298],
    [3364.00, 3375.99, 84.25, 8735428834],
    [3376.00, 3387.99, 84.55, 8735461602],
    [3388.00, 3399.99, 84.85, 8735592674],
    [3400.00, 3411.99, 85.15, 8735658210],
    [3412.00, 3423.99, 85.45, 8735723746],
    [3424.00, 3435.99, 85.75, 8735789282],
    [3436.00, 3447.99, 86.05, 8735854818],
    [3448.00, 3459.99, 86.35, 8735887586],
    [3460.00, 3471.99, 86.65, 8735953122],
    [3472.00, 3483.99, 86.95, 8736018658],
    [3484.00, 3495.99, 87.25, 8736084194],
    [3496.00, 3507.99, 87.55, 8736149730],
    [3508.00, 3519.99, 87.85, 8736182498],
    [3520.00, 3531.99, 88.15, 8736215266],
    [3532.00, 3543.99, 88.45, 8736248034],
    [3544.00, 3555.99, 88.75, 8736280802],
    [3556.00, 3567.99, 89.05, 8736313570],
    [3568.00, 3579.99, 89.35, 8736346338],
    [3580.00, 3591.99, 89.65, 8736379106],
    [3592.00, 3603.99, 89.95, 8736411874],
    [3604.00, 3615.99, 90.25, 8736444642],
    [3616.00, 3627.99, 90.55, 8736477410],
    [3628.00, 3639.99, 90.85, 8736510178],
    [3640.00, 3651.99, 91.15, 8736608482],
    [3652.00, 3663.99, 91.45, 8736641250],
    [3664.00, 3675.99, 91.75, 8736674018],
    [3676.00, 3687.99, 92.05, 8736706786],
    [3688.00, 3699.99, 92.35, 8736739554],
    [3700.00, 3711.99, 92.65, 8736772322],
    [3712.00, 3723.99, 92.95, 8736805090],
    [3724.00, 3735.99, 93.25, 8736837858],
    [3736.00, 3747.99, 93.55, 8736870626],
    [3748.00, 3759.99, 93.85, 8736903394],
    [3760.00, 3771.99, 94.15, 8736936162],
    [3772.00, 3783.99, 94.45, 8736968930],
    [3784.00, 3795.99, 94.75, 8737001698],
    [3796.00, 3807.99, 95.05, 8737034466],
    [3808.00, 3819.99, 95.35, 8737067234],
    [3820.00, 3831.99, 95.65, 8737100002],
    [3832.00, 3843.99, 95.95, 8737132770],
    [3844.00, 3855.99, 96.25, 8737165538],
    [3856.00, 3867.99, 96.55, 8737198306],
    [3868.00, 3879.99, 96.85, 8737231074],
    [3880.00, 3891.99, 97.15, 8737263842],
    [3892.00, 3903.99, 97.45, 8737296610],
    [3904.00, 3915.99, 97.75, 8737329378],
    [3916.00, 3927.99, 98.05, 8737362146],
    [3928.00, 3939.99, 98.35, 8737394914],
    [3940.00, 3951.99, 98.65, 8737427682],
    [3952.00, 3963.99, 98.95, 8737460450],
    [3964.00, 3975.99, 99.25, 8737493218],
    [3976.00, 3987.99, 99.55, 8737525986],
    [3988.00, 3999.99, 99.85, 8737558754],
    [4000.00, 4011.99, 100.15, 8737591522],
    [4012.00, 4023.99, 100.45, 8737624290],
    [4024.00, 4035.99, 100.75, 8737657058],
    [4036.00, 4047.99, 101.05, 8737689826],
    [4048.00, 4059.99, 101.35, 8737755362],
    [4060.00, 4071.99, 101.65, 8737788130],
    [4072.00, 4083.99, 101.95, 8737820898],
    [4084.00, 4095.99, 102.25, 8737853666],
    [4096.00, 4107.99, 102.55, 8737886434],
    [4108.00, 4119.99, 102.85, 8737919202],
    [4120.00, 4131.99, 103.15, 8737951970],
    [4132.00, 4143.99, 103.45, 8738017506],
    [4144.00, 4155.99, 103.75, 8738050274],
    [4156.00, 4167.99, 104.05, 8738083042],
    [4168.00, 4179.99, 104.35, 8738181346],
    [4180.00, 4191.99, 104.65, 8738509026],
    [4192.00, 4203.99, 104.95, 8738574562],
    [4204.00, 4215.99, 105.25, 8738607330],
    [4216.00, 4227.99, 105.55, 8738640098],
    [4228.00, 4239.99, 105.85, 8738672866],
    [4240.00, 4251.99, 106.15, 8738705634],
    [4252.00, 4263.99, 106.45, 8738738402],
    [4264.00, 4275.99, 106.75, 8738771170],
    [4276.00, 4287.99, 107.05, 8738803938],
    [4288.00, 4299.99, 107.35, 8738836706],
    [4300.00, 4311.99, 107.65, 8738869474],
    [4312.00, 4323.99, 107.95, 8738902242],
    [4324.00, 4335.99, 108.25, 8738935010],
    [4336.00, 4347.99, 108.55, 8738967778],
    [4348.00, 4359.99, 108.85, 8739000546],
    [4360.00, 4371.99, 109.15, 8739033314],
    [4372.00, 4383.99, 109.45, 8739066082],
    [4384.00, 4395.99, 109.75, 8739098850],
    [4396.00, 4407.99, 110.05, 8739131618],
    [4408.00, 4419.99, 110.35, 8739164386],
    [4420.00, 4431.99, 110.65, 8739197154],
    [4432.00, 4443.99, 110.95, 8739262690],
    [4444.00, 4455.99, 111.25, 8739295458],
    [4456.00, 4467.99, 111.55, 8739328226],
    [4468.00, 4479.99, 111.85, 8739360994],
    [4480.00, 4491.99, 112.15, 8739393762],
    [4492.00, 4503.99, 112.45, 8739426530],
    [4504.00, 4515.99, 112.75, 8739590370],
    [4516.00, 4527.99, 113.05, 8739623138],
    [4528.00, 4539.99, 113.35, 8739655906],
    [4540.00, 4551.99, 113.65, 8739688674],
    [4552.00, 4563.99, 113.95, 8739721442],
    [4564.00, 4575.99, 114.25, 8739754210],
    [4576.00, 4587.99, 114.55, 8739786978],
    [4588.00, 4599.99, 114.85, 8739819746],
    [4600.00, 4611.99, 115.15, 8739852514],
    [4612.00, 4623.99, 115.45, 8739885282],
    [4624.00, 4635.99, 115.75, 8739918050],
    [4636.00, 4647.99, 116.05, 8739950818],
    [4648.00, 4659.99, 116.35, 8739983586],
    [4660.00, 4671.99, 116.65, 8740016354],
    [4672.00, 4683.99, 116.95, 8740049122],
    [4684.00, 4695.99, 117.25, 8740081890],
    [4696.00, 4707.99, 117.55, 8740114658],
    [4708.00, 4719.99, 117.85, 8740147426],
    [4720.00, 4731.99, 118.15, 8740180194],
    [4732.00, 4743.99, 118.45, 8740212962],
    [4744.00, 4755.99, 118.75, 8740245730],
    [4756.00, 4767.99, 119.05, 8740278498],
    [4768.00, 4779.99, 119.35, 8740311266],
    [4780.00, 4791.99, 119.65, 8740344034],
    [4792.00, 4803.99, 119.95, 8740376802],
    [4804.00, 4815.99, 120.25, 8740409570],
    [4816.00, 4827.99, 120.55, 8740442338],
    [4828.00, 4839.99, 120.85, 8740540642],
    [4840.00, 4851.99, 121.15, 8740573410],
    [4852.00, 4863.99, 121.45, 8740606178],
    [4864.00, 4875.99, 121.75, 8740638946],
    [4876.00, 4887.99, 122.05, 8740671714],
    [4888.00, 4899.99, 122.35, 8740704482],
    [4900.00, 4911.99, 122.65, 8740737250],
    [4912.00, 4923.99, 122.95, 8740770018],
    [4924.00, 4935.99, 123.25, 8740802786],
    [4936.00, 4947.99, 123.55, 8740835554],
    [4948.00, 4959.99, 123.85, 8740868322],
    [4960.00, 4971.99, 124.15, 8740901090],
    [4972.00, 4983.99, 124.45, 8740966626],
    [4984.00, 4995.99, 124.75, 8740999394],
    [4996.00, 5007.99, 125.05, 8741032162],
    [5008.00, 5019.99, 125.35, 8741064930],
    [5020.00, 5031.99, 125.65, 8741097698],
    [5032.00, 5043.99, 125.95, 8741130466],
    [5044.00, 5055.99, 126.25, 8741163234],
    [5056.00, 5067.99, 126.55, 8741196002],
    [5068.00, 5079.99, 126.85, 8741228770],
    [5080.00, 5091.99, 127.15, 8741261538],
    [5092.00, 5103.99, 127.45, 8741359842],
    [5104.00, 5115.99, 127.75, 8741392610],
    [5116.00, 5127.99, 128.05, 8741425378],
    [5128.00, 5139.99, 128.35, 8741458146],
    [5140.00, 5151.99, 128.65, 8741490914],
    [5152.00, 5163.99, 128.95, 8741523682],
    [5164.00, 5175.99, 129.25, 8741556450],
    [5176.00, 5187.99, 129.55, 8741621986],
    [5188.00, 5199.99, 129.85, 8741654754],
    [5200.00, 5211.99, 130.15, 8741687522],
    [5212.00, 5223.99, 130.45, 8741720290],
    [5224.00, 5235.99, 130.75, 8741753058],
    [5236.00, 5247.99, 131.05, 8741785826],
    [5248.00, 5259.99, 131.35, 8741818594],
    [5260.00, 5271.99, 131.65, 8741851362],
    [5272.00, 5283.99, 131.95, 8741884130],
    [5284.00, 5295.99, 132.25, 8741982434],
    [5296.00, 5307.99, 132.55, 8742015202],
    [5308.00, 5319.99, 132.85, 8742047970],
    [5320.00, 5331.99, 133.15, 8742080738],
    [5332.00, 5343.99, 133.45, 8742113506],
    [5344.00, 5355.99, 133.75, 8742146274],
    [5356.00, 5367.99, 134.05, 8742179042],
    [5368.00, 5379.99, 134.35, 8742211810],
    [5380.00, 5391.99, 134.65, 8742244578],
    [5392.00, 5403.99, 134.95, 8742277346],
    [5404.00, 5415.99, 135.25, 8742342882],
    [5416.00, 5427.99, 135.55, 8742408418],
    [5428.00, 5439.99, 135.85, 8742441186],
    [5440.00, 5451.99, 136.15, 8742539490],
    [5452.00, 5463.99, 136.45, 8742572258],
    [5464.00, 5475.99, 136.75, 8742605026],
    [5476.00, 5487.99, 137.05, 8742670562],
    [5488.00, 5499.99, 137.35, 8742736098],
    [5500.00, 5511.99, 137.65, 8743031010],
    [5512.00, 5523.99, 137.95, 8743063778],
    [5524.00, 5535.99, 138.25, 8743096546],
    [5536.00, 5547.99, 138.55, 8743129314],
    [5548.00, 5559.99, 138.85, 8743162082],
    [5560.00, 5571.99, 139.15, 8743194850],
    [5572.00, 5583.99, 139.45, 8743227618],
    [5584.00, 5595.99, 139.75, 8743260386],
    [5596.00, 5607.99, 140.05, 8743325922],
    [5608.00, 5619.99, 140.35, 8743358690],
    [5620.00, 5631.99, 140.65, 8743653602],
    [5632.00, 5643.99, 140.95, 8743686370],
    [5644.00, 5655.99, 141.25, 8743719138],
    [5656.00, 5667.99, 141.55, 8743751906],
    [5668.00, 5679.99, 141.85, 8743784674],
    [5680.00, 5691.99, 142.15, 8743817442],
    [5692.00, 5703.99, 142.45, 8743850210],
    [5704.00, 5715.99, 142.75, 8743882978],
    [5716.00, 5727.99, 143.05, 8743915746],
    [5728.00, 5739.99, 143.35, 8743948514],
    [5740.00, 5751.99, 143.65, 8743981282],
    [5752.00, 5763.99, 143.95, 8744014050],
    [5764.00, 5775.99, 144.25, 8744046818],
    [5776.00, 5787.99, 144.55, 8744079586],
    [5788.00, 5799.99, 144.85, 8744112354],
    [5800.00, 5811.99, 145.15, 8744145122],
    [5812.00, 5823.99, 145.45, 8744177890],
    [5824.00, 5835.99, 145.75, 8744210658],
    [5836.00, 5847.99, 146.05, 8744243426],
    [5848.00, 5859.99, 146.35, 8744276194],
    [5860.00, 5871.99, 146.65, 8744308962],
    [5872.00, 5883.99, 146.95, 8744341730],
    [5884.00, 5895.99, 147.25, 8744374498],
    [5896.00, 5907.99, 147.55, 8744407266],
    [5908.00, 5919.99, 147.85, 8744440034],
    [5920.00, 5931.99, 148.15, 8744472802],
    [5932.00, 5943.99, 148.45, 8744505570],
    [5944.00, 5955.99, 148.75, 8744538338],
    [5956.00, 5967.99, 149.05, 8744571106],
    [5968.00, 5979.99, 149.35, 8744603874],
    [5980.00, 5991.99, 149.65, 8744636642],
    [5992.00, 6003.99, 149.95, 8744669410],
    [6004.00, 6015.99, 150.25, 8744702178],
    [6016.00, 6027.99, 150.55, 8744734946],
    [6028.00, 6039.99, 150.85, 8744767714],
    [6040.00, 6051.99, 151.15, 8744800482],
    [6052.00, 6063.99, 151.45, 8744833250],
    [6064.00, 6075.99, 151.75, 8744866018],
    [6076.00, 6087.99, 152.05, 8744898786],
    [6088.00, 6099.99, 152.35, 8744964322],
    [6100.00, 6111.99, 152.65, 8744997090],
    [6112.00, 6123.99, 152.95, 8745029858],
    [6124.00, 6135.99, 153.25, 8745062626],
    [6136.00, 6147.99, 153.55, 8745128162],
    [6148.00, 6159.99, 153.85, 8745160930],
    [6160.00, 6171.99, 154.15, 8745193698],
    [6172.00, 6183.99, 154.45, 8745226466],
    [6184.00, 6195.99, 154.75, 8745259234],
    [6196.00, 6207.99, 155.05, 8745292002],
    [6208.00, 6219.99, 155.35, 8745324770],
    [6220.00, 6231.99, 155.65, 8745357538],
    [6232.00, 6243.99, 155.95, 8745390306],
    [6244.00, 6255.99, 156.25, 8745423074],
    [6256.00, 6267.99, 156.55, 8745455842],
    [6268.00, 6279.99, 156.85, 8745488610],
    [6280.00, 6291.99, 157.15, 8745521378],
    [6292.00, 6303.99, 157.45, 8745554146],
    [6304.00, 6315.99, 157.75, 8745586914],
    [6316.00, 6327.99, 158.05, 8745619682],
    [6328.00, 6339.99, 158.35, 8745652450],
    [6340.00, 6351.99, 158.65, 8745685218],
    [6352.00, 6363.99, 158.95, 8745717986],
    [6364.00, 6375.99, 159.25, 8745750754],
    [6376.00, 6387.99, 159.55, 8745783522],
    [6388.00, 6399.99, 159.85, 8745816290],
    [6400.00, 6411.99, 160.15, 8745849058],
    [6412.00, 6423.99, 160.45, 8745881826],
    [6424.00, 6435.99, 160.75, 8745914594],
    [6436.00, 6447.99, 161.05, 8745947362],
    [6448.00, 6459.99, 161.35, 8745980130],
    [6460.00, 6471.99, 161.65, 8746012898],
    [6472.00, 6483.99, 161.95, 8746045666],
    [6484.00, 6495.99, 162.25, 8746078434],
    [6496.00, 6507.99, 162.55, 8746111202],
    [6508.00, 6519.99, 162.85, 8746143970],
    [6520.00, 6531.99, 163.15, 8746176738],
    [6532.00, 6543.99, 163.45, 8746209506],
    [6544.00, 6555.99, 163.75, 8746242274],
    [6556.00, 6567.99, 164.05, 8746275042],
    [6568.00, 6579.99, 164.35, 8746307810],
    [6580.00, 6591.99, 164.65, 8746340578],
    [6592.00, 6603.99, 164.95, 8746373346],
    [6604.00, 6615.99, 165.25, 8746406114],
    [6616.00, 6627.99, 165.55, 8746438882],
    [6628.00, 6639.99, 165.85, 8746504418],
    [6640.00, 6651.99, 166.15, 8746537186],
    [6652.00, 6663.99, 166.45, 8746569954],
    [6664.00, 6675.99, 166.75, 8746602722],
    [6676.00, 6687.99, 167.05, 8746635490],
    [6688.00, 6699.99, 167.35, 8746668258],
    [6700.00, 6711.99, 167.65, 8746733794],
    [6712.00, 6723.99, 167.95, 8746766562],
    [6724.00, 6735.99, 168.25, 8746799330],
    [6736.00, 6747.99, 168.55, 8746832098],
    [6748.00, 6759.99, 168.85, 8746864866],
    [6760.00, 6771.99, 169.15, 8746897634],
    [6772.00, 6783.99, 169.45, 8746930402],
    [6784.00, 6795.99, 169.75, 8746963170],
    [6796.00, 6807.99, 170.05, 8746995938],
    [6808.00, 6819.99, 170.35, 8747028706],
    [6820.00, 6831.99, 170.65, 8747061474],
    [6832.00, 6843.99, 170.95, 8747094242],
    [6844.00, 6855.99, 171.25, 8747127010],
    [6856.00, 6867.99, 171.55, 8747159778],
    [6868.00, 6879.99, 171.85, 8747192546],
    [6880.00, 6891.99, 172.15, 8747225314],
    [6892.00, 6903.99, 172.45, 8747258082],
    [6904.00, 6915.99, 172.75, 8747323618],
    [6916.00, 6927.99, 173.05, 8747389154],
    [6928.00, 6939.99, 173.35, 8747421922],
    [6940.00, 6951.99, 173.65, 8747454690],
    [6952.00, 6963.99, 173.95, 8747487458],
    [6964.00, 6975.99, 174.25, 8747520226],
    [6976.00, 6987.99, 174.55, 8747552994],
    [6988.00, 6999.99, 174.85, 8747585762],
    [7000.00, 7011.99, 175.15, 8747618530],
    [7012.00, 7023.99, 175.45, 8747651298],
    [7024.00, 7035.99, 175.75, 8747684066],
    [7036.00, 7047.99, 176.05, 8747716834],
    [7048.00, 7059.99, 176.35, 8747749602],
    [7060.00, 7071.99, 176.65, 8747782370],
    [7072.00, 7083.99, 176.95, 8747815138],
    [7084.00, 7095.99, 177.25, 8747847906],
    [7096.00, 7107.99, 177.55, 8748011746],
    [7108.00, 7119.99, 177.85, 8748044514],
    [7120.00, 7131.99, 178.15, 8748077282],
    [7132.00, 7143.99, 178.45, 8748110050],
    [7144.00, 7155.99, 178.75, 8748142818],
    [7156.00, 7167.99, 179.05, 8748208354],
    [7168.00, 7179.99, 179.35, 8748306658],
    [7180.00, 7191.99, 179.65, 8748372194],
    [7192.00, 7203.99, 179.95, 8748437730],
    [7204.00, 7215.99, 180.25, 8748470498],
    [7216.00, 7227.99, 180.55, 8748503266],
    [7228.00, 7239.99, 180.85, 8748536034],
    [7240.00, 7251.99, 181.15, 8748568802],
    [7252.00, 7263.99, 181.45, 8748601570],
    [7264.00, 7275.99, 181.75, 8748634338],
    [7276.00, 7287.99, 182.05, 8748667106],
    [7288.00, 7299.99, 182.35, 8748699874],
    [7300.00, 7311.99, 182.65, 8748732642],
    [7312.00, 7323.99, 182.95, 8748765410],
    [7324.00, 7335.99, 183.25, 8748798178],
    [7336.00, 7347.99, 183.55, 8748830946],
    [7348.00, 7359.99, 183.85, 8748863714],
    [7360.00, 7371.99, 184.15, 8748896482],
    [7372.00, 7383.99, 184.45, 8748929250],
    [7384.00, 7395.99, 184.75, 8748962018],
    [7396.00, 7407.99, 185.05, 8748994786],
    [7408.00, 7419.99, 185.35, 8749027554],
    [7420.00, 7431.99, 185.65, 8749060322],
    [7432.00, 7443.99, 185.95, 8749093090],
    [7444.00, 7455.99, 186.25, 8749125858],
    [7456.00, 7467.99, 186.55, 8749158626],
    [7468.00, 7479.99, 186.85, 8749191394],
    [7480.00, 7491.99, 187.15, 8749224162],
    [7492.00, 7503.99, 187.45, 8749256930],
    [7504.00, 7515.99, 187.75, 8749289698],
    [7516.00, 7527.99, 188.05, 8749322466],
    [7528.00, 7539.99, 188.35, 8749355234],
    [7540.00, 7551.99, 188.65, 8749388002],
    [7552.00, 7563.99, 188.95, 8749420770],
    [7564.00, 7575.99, 189.25, 8749453538],
    [7576.00, 7587.99, 189.55, 8749486306],
    [7588.00, 7599.99, 189.85, 8749519074],
    [7600.00, 7611.99, 190.15, 8749551842],
    [7612.00, 7623.99, 190.45, 8749584610],
    [7624.00, 7635.99, 190.75, 8749617378],
    [7636.00, 7647.99, 191.05, 8749650146],
    [7648.00, 7659.99, 191.35, 8749682914],
    [7660.00, 7671.99, 191.65, 8749715682],
    [7672.00, 7683.99, 191.95, 8749748450],
    [7684.00, 7695.99, 192.25, 8749781218],
    [7696.00, 7707.99, 192.55, 8749813986],
    [7708.00, 7719.99, 192.85, 8749846754],
    [7720.00, 7731.99, 193.15, 8749879522],
    [7732.00, 7743.99, 193.45, 8749912290],
    [7744.00, 7755.99, 193.75, 8749945058],
    [7756.00, 7767.99, 194.05, 8749977826],
    [7768.00, 7779.99, 194.35, 8750010594],
    [7780.00, 7791.99, 194.65, 8750043362],
    [7792.00, 7803.99, 194.95, 8750076130],
    [7804.00, 7815.99, 195.25, 8750108898],
    [7816.00, 7827.99, 195.55, 8750141666],
    [7828.00, 7839.99, 195.85, 8750174434],
    [7840.00, 7851.99, 196.15, 8750239970],
    [7852.00, 7863.99, 196.45, 8750272738],
    [7864.00, 7875.99, 196.75, 8750305506],
    [7876.00, 7887.99, 197.05, 8750338274],
    [7888.00, 7899.99, 197.35, 8750371042],
    [7900.00, 7911.99, 197.65, 8750403810],
    [7912.00, 7923.99, 197.95, 8750436578],
    [7924.00, 7935.99, 198.25, 8750600418],
    [7936.00, 7947.99, 198.55, 8751026402],
    [7948.00, 7959.99, 198.85, 8751452386],
    [7960.00, 7971.99, 199.15, 8751747298],
    [7972.00, 7983.99, 199.45, 8751911138],
    [7984.00, 7995.99, 199.75, 8752468194],
    [7996.00, 8007.99, 200.05, 8752632034],
    [8008.00, 8019.99, 200.35, 8752926946],
    [8020.00, 8031.99, 200.65, 8753516770],
    [8032.00, 8043.99, 200.95, 8753549538],
    [8044.00, 8055.99, 201.25, 8753582306],
    [8056.00, 8067.99, 201.55, 8753615074],
    [8068.00, 8079.99, 201.85, 8753647842],
    [8080.00, 8091.99, 202.15, 8753680610],
    [8092.00, 8103.99, 202.45, 8753713378],
    [8104.00, 8115.99, 202.75, 8753746146],
    [8116.00, 8127.99, 203.05, 8753778914],
    [8128.00, 8139.99, 203.35, 8753811682],
    [8140.00, 8151.99, 203.65, 8753844450],
    [8152.00, 8163.99, 203.95, 8753877218],
    [8164.00, 8175.99, 204.25, 8753909986],
    [8176.00, 8187.99, 204.55, 8753942754],
    [8188.00, 8199.99, 204.85, 8753975522],
    [8200.00, 8211.99, 205.15, 8754008290],
    [8212.00, 8223.99, 205.45, 8754041058],
    [8224.00, 8235.99, 205.75, 8754073826],
    [8236.00, 8247.99, 206.05, 8754106594],
    [8248.00, 8259.99, 206.35, 8754139362],
    [8260.00, 8271.99, 206.65, 8754172130],
    [8272.00, 8283.99, 206.95, 8754204898],
    [8284.00, 8295.99, 207.25, 8754237666],
    [8296.00, 8307.99, 207.55, 8754270434],
    [8308.00, 8319.99, 207.85, 8754303202],
    [8320.00, 8331.99, 208.15, 8754335970],
    [8332.00, 8343.99, 208.45, 8754368738],
    [8344.00, 8355.99, 208.75, 8754401506],
    [8356.00, 8367.99, 209.05, 8754467042],
    [8368.00, 8379.99, 209.35, 8754499810],
    [8380.00, 8391.99, 209.65, 8754532578],
    [8392.00, 8403.99, 209.95, 8754598114],
    [8404.00, 8415.99, 210.25, 8754630882],
    [8416.00, 8427.99, 210.55, 8754663650],
    [8428.00, 8439.99, 210.85, 8754696418],
    [8440.00, 8451.99, 211.15, 8754729186],
    [8452.00, 8463.99, 211.45, 8754761954],
    [8464.00, 8475.99, 211.75, 8754794722],
    [8476.00, 8487.99, 212.05, 8754827490],
    [8488.00, 8499.99, 212.35, 8754893026],
    [8500.00, 8511.99, 212.65, 8754991330],
    [8512.00, 8523.99, 212.95, 8755122402],
    [8524.00, 8535.99, 213.25, 8755220706],
    [8536.00, 8547.99, 213.55, 8755351778],
    [8548.00, 8559.99, 213.85, 8755450082],
    [8560.00, 8571.99, 214.15, 8755613922],
    [8572.00, 8583.99, 214.45, 8755908834],
    [8584.00, 8595.99, 214.75, 8755974370],
    [8596.00, 8607.99, 215.05, 8756039906],
    [8608.00, 8619.99, 215.35, 8756072674],
    [8620.00, 8631.99, 215.65, 8756105442],
    [8632.00, 8643.99, 215.95, 8756138210],
    [8644.00, 8655.99, 216.25, 8756170978],
    [8656.00, 8667.99, 216.55, 8756203746],
    [8668.00, 8679.99, 216.85, 8756236514],
    [8680.00, 8691.99, 217.15, 8756465890],
    [8692.00, 8703.99, 217.45, 8756498658],
    [8704.00, 8715.99, 217.75, 8756531426],
    [8716.00, 8727.99, 218.05, 8756564194],
    [8728.00, 8739.99, 218.35, 8756596962],
    [8740.00, 8751.99, 218.65, 8756629730],
    [8752.00, 8763.99, 218.95, 8756662498],
    [8764.00, 8775.99, 219.25, 8756695266],
    [8776.00, 8787.99, 219.55, 8756728034],
    [8788.00, 8799.99, 219.85, 8756760802],
    [8800.00, 8811.99, 220.15, 8756793570],
    [8812.00, 8823.99, 220.45, 8756826338],
    [8824.00, 8835.99, 220.75, 8756859106],
    [8836.00, 8847.99, 221.05, 8756891874],
    [8848.00, 8859.99, 221.35, 8756924642],
    [8860.00, 8871.99, 221.65, 8756957410],
    [8872.00, 8883.99, 221.95, 8756990178],
    [8884.00, 8895.99, 222.25, 8757022946],
    [8896.00, 8907.99, 222.55, 8757055714],
    [8908.00, 8919.99, 222.85, 8757088482],
    [8920.00, 8931.99, 223.15, 8757121250],
    [8932.00, 8943.99, 223.45, 8757154018],
    [8944.00, 8955.99, 223.75, 8757186786],
    [8956.00, 8967.99, 224.05, 8757219554],
    [8968.00, 8979.99, 224.35, 8757252322],
    [8980.00, 8991.99, 224.65, 8757285090],
    [8992.00, 9003.99, 224.95, 8757448930],
    [9004.00, 9015.99, 225.25, 8757481698],
    [9016.00, 9027.99, 225.55, 8757514466],
    [9028.00, 9039.99, 225.85, 8757612770],
    [9040.00, 9051.99, 226.15, 8757645538],
    [9052.00, 9063.99, 226.45, 8757678306],
    [9064.00, 9075.99, 226.75, 8757711074],
    [9076.00, 9087.99, 227.05, 8757743842],
    [9088.00, 9099.99, 227.35, 8757776610],
    [9100.00, 9111.99, 227.65, 8757809378],
    [9112.00, 9123.99, 227.95, 8757842146],
    [9124.00, 9135.99, 228.25, 8757874914],
    [9136.00, 9147.99, 228.55, 8757907682],
    [9148.00, 9159.99, 228.85, 8757940450],
    [9160.00, 9171.99, 229.15, 8757973218],
    [9172.00, 9183.99, 229.45, 8758005986],
    [9184.00, 9195.99, 229.75, 8758038754],
    [9196.00, 9207.99, 230.05, 8758071522],
    [9208.00, 9219.99, 230.35, 8758104290],
    [9220.00, 9231.99, 230.65, 8758137058],
    [9232.00, 9243.99, 230.95, 8758169826],
    [9244.00, 9255.99, 231.25, 8758202594],
    [9256.00, 9267.99, 231.55, 8758235362],
    [9268.00, 9279.99, 231.85, 8758300898],
    [9280.00, 9291.99, 232.15, 8758333666],
    [9292.00, 9303.99, 232.45, 8758366434],
    [9304.00, 9315.99, 232.75, 8758399202],
    [9316.00, 9327.99, 233.05, 8758431970],
    [9328.00, 9339.99, 233.35, 8758464738],
    [9340.00, 9351.99, 233.65, 8758497506],
    [9352.00, 9363.99, 233.95, 8758530274],
    [9364.00, 9375.99, 234.25, 8778649826],
    [9376.00, 9387.99, 234.55, 8778715362],
    [9388.00, 9399.99, 234.85, 8778780898],
    [9400.00, 9411.99, 235.15, 8778846434],
    [9412.00, 9423.99, 235.45, 8778944738],
    [9424.00, 9435.99, 235.75, 8779010274],
    [9436.00, 9447.99, 236.05, 8779043042],
    [9448.00, 9459.99, 236.35, 8779141346],
    [9460.00, 9471.99, 236.65, 8779272418],
    [9472.00, 9483.99, 236.95, 8779370722],
    [9484.00, 9495.99, 237.25, 8779501794],
    [9496.00, 9507.99, 237.55, 8779632866],
    [9508.00, 9519.99, 237.85, 8779731170],
    [9520.00, 9531.99, 238.15, 8779829474],
    [9532.00, 9543.99, 238.45, 8779895010],
    [9544.00, 9555.99, 238.75, 8780026082],
    [9556.00, 9567.99, 239.05, 8780124386],
    [9568.00, 9579.99, 239.35, 8780222690],
    [9580.00, 9591.99, 239.65, 8780320994],
    [9592.00, 9603.99, 239.95, 8780452066],
    [9604.00, 9615.99, 240.25, 8780550370],
    [9616.00, 9627.99, 240.55, 8780648674],
    [9628.00, 9639.99, 240.85, 8780714210],
    [9640.00, 9651.99, 241.15, 8780779746],
    [9652.00, 9663.99, 241.45, 8780845282],
    [9664.00, 9675.99, 241.75, 8780943586],
    [9676.00, 9687.99, 242.05, 8781041890],
    [9688.00, 9699.99, 242.35, 8781140194],
    [9700.00, 9711.99, 242.65, 8781205730],
    [9712.00, 9723.99, 242.95, 8781304034],
    [9724.00, 9735.99, 243.25, 8781402338],
    [9736.00, 9747.99, 243.55, 8781467874],
    [9748.00, 9759.99, 243.85, 8781566178],
    [9760.00, 9771.99, 244.15, 8781664482],
    [9772.00, 9783.99, 244.45, 8781762786],
    [9784.00, 9795.99, 244.75, 8781828322],
    [9796.00, 9807.99, 245.05, 8781893858],
    [9808.00, 9819.99, 245.35, 8781992162],
    [9820.00, 9831.99, 245.65, 8782057698],
    [9832.00, 9843.99, 245.95, 8782156002],
    [9844.00, 9855.99, 246.25, 8782221538],
    [9856.00, 9867.99, 246.55, 8782319842],
    [9868.00, 9879.99, 246.85, 8782385378],
    [9880.00, 9891.99, 247.15, 8782483682],
    [9892.00, 9903.99, 247.45, 8782549218],
    [9904.00, 9915.99, 247.75, 8782647522],
    [9916.00, 9927.99, 248.05, 8782713058],
    [9928.00, 9939.99, 248.35, 8782811362],
    [9940.00, 9951.99, 248.65, 8782909666],
    [9952.00, 9963.99, 248.95, 8783007970],
    [9964.00, 9975.99, 249.25, 8783106274],
    [9976.00, 9987.99, 249.55, 8783204578],
    [9988.00, 9999.99, 249.85, 8783302882],
    [10000.00, 10011.99, 250.15, 8783335650],
    [10012.00, 10023.99, 250.45, 8783433954],
    [10024.00, 10035.99, 250.75, 8783532258],
    [10036.00, 10047.99, 251.05, 8783630562],
    [10048.00, 10059.99, 251.35, 8783728866],
    [10060.00, 10071.99, 251.65, 8783859938],
    [10072.00, 10083.99, 251.95, 8783925474],
    [10084.00, 10095.99, 252.25, 8784023778],
    [10096.00, 10107.99, 252.55, 8784122082],
    [10108.00, 10119.99, 252.85, 8784253154],
    [10120.00, 10131.99, 253.15, 8784351458],
    [10132.00, 10143.99, 253.45, 8784449762],
    [10144.00, 10155.99, 253.75, 8784548066],
    [10156.00, 10167.99, 254.05, 8784646370],
    [10168.00, 10179.99, 254.35, 8784711906],
    [10180.00, 10191.99, 254.65, 8784842978],
    [10192.00, 10203.99, 254.95, 8784941282],
    [10204.00, 10215.99, 255.25, 8785039586],
    [10216.00, 10227.99, 255.55, 8785137890],
    [10228.00, 10239.99, 255.85, 8785236194],
    [10240.00, 10251.99, 256.15, 8785367266],
    [10252.00, 10263.99, 256.45, 8785465570],
    [10264.00, 10275.99, 256.75, 8785563874],
    [10276.00, 10287.99, 257.05, 8785662178],
    [10288.00, 10299.99, 257.35, 8785760482],
    [10300.00, 10311.99, 257.65, 8785858786],
    [10312.00, 10323.99, 257.95, 8785957090],
    [10324.00, 10335.99, 258.25, 8786055394],
    [10336.00, 10347.99, 258.55, 8786186466],
    [10348.00, 10359.99, 258.85, 8786284770],
    [10360.00, 10371.99, 259.15, 8786415842],
    [10372.00, 10383.99, 259.45, 8786514146],
    [10384.00, 10395.99, 259.75, 8786612450],
    [10396.00, 10407.99, 260.05, 8786710754],
    [10408.00, 10419.99, 260.35, 8786809058],
    [10420.00, 10431.99, 260.65, 8786940130],
    [10432.00, 10443.99, 260.95, 8787038434],
    [10444.00, 10455.99, 261.25, 8787169506],
    [10456.00, 10467.99, 261.55, 8787267810],
    [10468.00, 10479.99, 261.85, 8787366114],
    [10480.00, 10491.99, 262.15, 8787431650],
    [10492.00, 10503.99, 262.45, 8787529954],
    [10504.00, 10515.99, 262.75, 8787628258],
    [10516.00, 10527.99, 263.05, 8787726562],
    [10528.00, 10539.99, 263.35, 8787792098],
    [10540.00, 10551.99, 263.65, 8787890402],
    [10552.00, 10563.99, 263.95, 8788021474],
    [10564.00, 10575.99, 264.25, 8788119778],
    [10576.00, 10587.99, 264.55, 8788218082],
    [10588.00, 10599.99, 264.85, 8788316386],
    [10600.00, 10611.99, 265.15, 8788414690],
    [10612.00, 10623.99, 265.45, 8788512994],
    [10624.00, 10635.99, 265.75, 8788611298],
    [10636.00, 10647.99, 266.05, 8788709602],
    [10648.00, 10659.99, 266.35, 8788807906],
    [10660.00, 10671.99, 266.65, 8788906210],
    [10672.00, 10683.99, 266.95, 8789037282],
    [10684.00, 10695.99, 267.25, 8789102818],
    [10696.00, 10707.99, 267.55, 8789168354],
    [10708.00, 10719.99, 267.85, 8789233890],
    [10720.00, 10731.99, 268.15, 8789299426],
    [10732.00, 10743.99, 268.45, 8789397730],
    [10744.00, 10755.99, 268.75, 8789496034],
    [10756.00, 10767.99, 269.05, 8789561570],
    [10768.00, 10779.99, 269.35, 8789692642],
    [10780.00, 10791.99, 269.65, 8789758178],
    [10792.00, 10803.99, 269.95, 8789856482],
    [10804.00, 10815.99, 270.25, 8789954786],
    [10816.00, 10827.99, 270.55, 8790053090],
    [10828.00, 10839.99, 270.85, 8790118626],
    [10840.00, 10851.99, 271.15, 8790380770],
    [10852.00, 10863.99, 271.45, 8790479074],
    [10864.00, 10875.99, 271.75, 8790577378],
    [10876.00, 10887.99, 272.05, 8790642914],
    [10888.00, 10899.99, 272.35, 8790708450],
    [10900.00, 10911.99, 272.65, 8790773986],
    [10912.00, 10923.99, 272.95, 8790806754],
    [10924.00, 10935.99, 273.25, 8790872290],
    [10936.00, 10947.99, 273.55, 8790937826],
    [10948.00, 10959.99, 273.85, 8791658722],
    [10960.00, 10971.99, 274.15, 8791724258],
    [10972.00, 10983.99, 274.45, 8791757026],
    [10984.00, 10995.99, 274.75, 8791953634],
    [10996.00, 11007.99, 275.05, 8792051938],
    [11008.00, 11019.99, 275.35, 8792510690],
    [11020.00, 11031.99, 275.65, 8792608994],
    [11032.00, 11043.99, 275.95, 8792936674],
    [11044.00, 11055.99, 276.25, 8793034978],
    [11056.00, 11067.99, 276.55, 8793395426],
    [11068.00, 11079.99, 276.85, 8793493730],
    [11080.00, 11091.99, 277.15, 8793624802],
    [11092.00, 11103.99, 277.45, 8793723106],
    [11104.00, 11115.99, 277.75, 8794116322],
    [11116.00, 11127.99, 278.05, 8794214626],
    [11128.00, 11139.99, 278.35, 8794280162],
    [11140.00, 11151.99, 278.65, 8794706146],
    [11152.00, 11163.99, 278.95, 8794804450],
    [11164.00, 11175.99, 279.25, 8797065442],
    [11176.00, 11187.99, 279.55, 8797163746],
    [11188.00, 11199.99, 279.85, 8799031522],
    [11200.00, 11211.99, 280.15, 8799097058],
    [11212.00, 11223.99, 280.45, 8799228130],
    [11224.00, 11235.99, 280.75, 8799326434],
    [11236.00, 11247.99, 281.05, 8799391970],
    [11248.00, 11259.99, 281.35, 8799490274],
    [11260.00, 11271.99, 281.65, 8799621346],
    [11272.00, 11283.99, 281.95, 8799686882],
    [11284.00, 11295.99, 282.25, 8799752418],
    [11296.00, 11307.99, 282.55, 8799850722],
    [11308.00, 11319.99, 282.85, 8799916258],
    [11320.00, 11331.99, 283.15, 8800014562],
    [11332.00, 11343.99, 283.45, 8800145634],
    [11344.00, 11355.99, 283.75, 8800243938],
    [11356.00, 11367.99, 284.05, 8800375010],
    [11368.00, 11379.99, 284.35, 8800440546],
    [11380.00, 11391.99, 284.65, 8800538850],
    [11392.00, 11403.99, 284.95, 8800637154],
    [11404.00, 11415.99, 285.25, 8800735458],
    [11416.00, 11427.99, 285.55, 8800833762],
    [11428.00, 11439.99, 285.85, 8800899298],
    [11440.00, 11451.99, 286.15, 8825213154],
    [11452.00, 11463.99, 286.45, 8825344226],
    [11464.00, 11475.99, 286.75, 8825409762],
    [11476.00, 11487.99, 287.05, 8825508066],
    [11488.00, 11499.99, 287.35, 8825573602],
    [11500.00, 11511.99, 287.65, 8825639138],
    [11512.00, 11523.99, 287.95, 8825737442],
    [11524.00, 11535.99, 288.25, 8825835746],
    [11536.00, 11547.99, 288.55, 8825934050],
    [11548.00, 11559.99, 288.85, 8825999586],
    [11560.00, 11571.99, 289.15, 8826097890],
    [11572.00, 11583.99, 289.45, 8826196194],
    [11584.00, 11595.99, 289.75, 8826261730],
    [11596.00, 11607.99, 290.05, 8826360034],
    [11608.00, 11619.99, 290.35, 8826425570],
    [11620.00, 11631.99, 290.65, 8826523874],
    [11632.00, 11643.99, 290.95, 8826589410],
    [11644.00, 11655.99, 291.25, 8826687714],
    [11656.00, 11667.99, 291.55, 8826786018],
    [11668.00, 11679.99, 291.85, 8826884322],
    [11680.00, 11691.99, 292.15, 8826949858],
    [11692.00, 11703.99, 292.45, 8827048162],
    [11704.00, 11715.99, 292.75, 8827146466],
    [11716.00, 11727.99, 293.05, 8827212002],
    [11728.00, 11739.99, 293.35, 8827310306],
    [11740.00, 11751.99, 293.65, 8827375842],
    [11752.00, 11763.99, 293.95, 8827474146],
    [11764.00, 11775.99, 294.25, 8827539682],
    [11776.00, 11787.99, 294.55, 8827637986],
    [11788.00, 11799.99, 294.85, 8827736290],
    [11800.00, 11811.99, 295.15, 8827801826],
    [11812.00, 11823.99, 295.45, 8827900130],
    [11824.00, 11835.99, 295.75, 8827965666],
    [11836.00, 11847.99, 296.05, 8828063970],
    [11848.00, 11859.99, 296.35, 8828129506],
    [11860.00, 11871.99, 296.65, 8828227810],
    [11872.00, 11883.99, 296.95, 8828326114],
    [11884.00, 11895.99, 297.25, 8828424418],
    [11896.00, 11907.99, 297.55, 8828915938],
    [11908.00, 11919.99, 297.85, 8828981474],
    [11920.00, 11931.99, 298.15, 8829079778],
    [11932.00, 11943.99, 298.45, 8829178082],
    [11944.00, 11955.99, 298.75, 8829276386],
    [11956.00, 11967.99, 299.05, 8829374690],
    [11968.00, 11979.99, 299.35, 8829440226],
    [11980.00, 11991.99, 299.65, 8829538530],
    [11992.00, 12003.99, 299.95, 8829964514],
    [12004.00, 12015.99, 300.25, 8830030050],
    [12016.00, 12027.99, 300.55, 8830128354],
    [12028.00, 12039.99, 300.85, 8830193890],
    [12040.00, 12051.99, 301.15, 8830292194],
    [12052.00, 12063.99, 301.45, 8830390498],
    [12064.00, 12075.99, 301.75, 8830456034],
    [12076.00, 12087.99, 302.05, 8830587106],
    [12088.00, 12099.99, 302.35, 8830652642],
    [12100.00, 12111.99, 302.65, 8830750946],
    [12112.00, 12123.99, 302.95, 8830816482],
    [12124.00, 12135.99, 303.25, 8830914786],
    [12136.00, 12147.99, 303.55, 8831308002],
    [12148.00, 12159.99, 303.85, 8831373538],
    [12160.00, 12171.99, 304.15, 8831471842],
    [12172.00, 12183.99, 304.45, 8831570146],
    [12184.00, 12195.99, 304.75, 8831668450],
    [12196.00, 12207.99, 305.05, 8831766754],
    [12208.00, 12219.99, 305.35, 8831832290],
    [12220.00, 12231.99, 305.65, 8831865058],
    [12232.00, 12243.99, 305.95, 8831897826],
    [12244.00, 12255.99, 306.25, 8831930594],
    [12256.00, 12267.99, 306.55, 8831963362],
    [12268.00, 12279.99, 306.85, 8831996130],
    [12280.00, 12291.99, 307.15, 8832028898],
    [12292.00, 12303.99, 307.45, 8832061666],
    [12304.00, 12315.99, 307.75, 8832094434],
    [12316.00, 12327.99, 308.05, 8832454882],
    [12328.00, 12339.99, 308.35, 8832487650],
    [12340.00, 12351.99, 308.65, 8833831138],
    [12352.00, 12363.99, 308.95, 8835338466],
    [12364.00, 12375.99, 309.25, 8835371234],
    [12376.00, 12387.99, 309.55, 8835404002],
    [12388.00, 12399.99, 309.85, 8835436770],
    [12400.00, 12411.99, 310.15, 8835469538],
    [12412.00, 12423.99, 310.45, 8835502306],
    [12424.00, 12435.99, 310.75, 8835535074],
    [12436.00, 12447.99, 311.05, 8835567842],
    [12448.00, 12459.99, 311.35, 8835600610],
    [12460.00, 12471.99, 311.65, 8835633378],
    [12472.00, 12483.99, 311.95, 8835666146],
    [12484.00, 12495.99, 312.25, 8835698914],
    [12496.00, 12507.99, 312.55, 8835731682],
    [12508.00, 12519.99, 312.85, 8835764450],
    [12520.00, 12531.99, 313.15, 8835993826],
    [12532.00, 12543.99, 313.45, 8836026594],
    [12544.00, 12555.99, 313.75, 8836059362],
    [12556.00, 12567.99, 314.05, 8838451426],
    [12568.00, 12579.99, 314.35, 8838484194],
    [12580.00, 12591.99, 314.65, 8838516962],
    [12592.00, 12603.99, 314.95, 8838549730],
    [12604.00, 12615.99, 315.25, 8838582498],
    [12616.00, 12627.99, 315.55, 8838615266],
    [12628.00, 12639.99, 315.85, 8838648034],
    [12640.00, 12651.99, 316.15, 8838680802],
    [12652.00, 12663.99, 316.45, 8838713570],
    [12664.00, 12675.99, 316.75, 8838746338],
    [12676.00, 12687.99, 317.05, 8838779106],
    [12688.00, 12699.99, 317.35, 8838811874],
    [12700.00, 12711.99, 317.65, 8838844642],
    [12712.00, 12723.99, 317.95, 8838877410],
    [12724.00, 12735.99, 318.25, 8838910178],
    [12736.00, 12747.99, 318.55, 8838942946],
    [12748.00, 12759.99, 318.85, 8838975714],
    [12760.00, 12771.99, 319.15, 8839008482],
    [12772.00, 12783.99, 319.45, 8839041250],
    [12784.00, 12795.99, 319.75, 8839074018],
    [12796.00, 12807.99, 320.05, 8839106786],
    [12808.00, 12819.99, 320.35, 8839139554],
    [12820.00, 12831.99, 320.65, 8839303394],
    [12832.00, 12843.99, 320.95, 8839336162],
    [12844.00, 12855.99, 321.25, 8839565538],
    [12856.00, 12867.99, 321.55, 8839598306],
    [12868.00, 12879.99, 321.85, 8839631074],
    [12880.00, 12891.99, 322.15, 8839663842],
    [12892.00, 12903.99, 322.45, 8839696610],
    [12904.00, 12915.99, 322.75, 8839729378],
    [12916.00, 12927.99, 323.05, 8839762146],
    [12928.00, 12939.99, 323.35, 8839794914],
    [12940.00, 12951.99, 323.65, 8839827682],
    [12952.00, 12963.99, 323.95, 8839860450],
    [12964.00, 12975.99, 324.25, 8839893218],
    [12976.00, 12987.99, 324.55, 8839925986],
    [12988.00, 12999.99, 324.85, 8839958754],
    [13000.00, 13011.99, 325.15, 8839991522],
    [13012.00, 13023.99, 325.45, 8840024290],
    [13024.00, 13035.99, 325.75, 8840057058],
    [13036.00, 13047.99, 326.05, 8840089826],
    [13048.00, 13059.99, 326.35, 8840122594],
    [13060.00, 13071.99, 326.65, 8840253666],
    [13072.00, 13083.99, 326.95, 8840286434],
    [13084.00, 13095.99, 327.25, 8840319202],
    [13096.00, 13107.99, 327.55, 8840351970],
    [13108.00, 13119.99, 327.85, 8840384738],
    [13120.00, 13131.99, 328.15, 8840417506],
    [13132.00, 13143.99, 328.45, 8840450274],
    [13144.00, 13155.99, 328.75, 8840483042],
    [13156.00, 13167.99, 329.05, 8840515810],
    [13168.00, 13179.99, 329.35, 8840548578],
    [13180.00, 13191.99, 329.65, 8840581346],
    [13192.00, 13203.99, 329.95, 8840614114],
    [13204.00, 13215.99, 330.25, 8840646882],
    [13216.00, 13227.99, 330.55, 8840679650],
    [13228.00, 13239.99, 330.85, 8840712418],
    [13240.00, 13251.99, 331.15, 8840745186],
    [13252.00, 13263.99, 331.45, 8840777954],
    [13264.00, 13275.99, 331.75, 8840810722],
    [13276.00, 13287.99, 332.05, 8840843490],
    [13288.00, 13299.99, 332.35, 8840876258],
    [13300.00, 13311.99, 332.65, 8841302242],
    [13312.00, 13323.99, 332.95, 8841859298],
    [13324.00, 13335.99, 333.25, 8842023138],
    [13336.00, 13347.99, 333.55, 8842318050],
    [13348.00, 13359.99, 333.85, 8842612962],
    [13360.00, 13371.99, 334.15, 8842907874],
    [13372.00, 13383.99, 334.45, 8843202786],
    [13384.00, 13395.99, 334.75, 8843628770],
    [13396.00, 13407.99, 335.05, 8843792610],
    [13408.00, 13419.99, 335.35, 8843825378],
    [13420.00, 13431.99, 335.65, 8843858146],
    [13432.00, 13443.99, 335.95, 8843890914],
    [13444.00, 13455.99, 336.25, 8843923682],
    [13456.00, 13467.99, 336.55, 8843956450],
    [13468.00, 13479.99, 336.85, 8843989218],
    [13480.00, 13491.99, 337.15, 8844021986],
    [13492.00, 13503.99, 337.45, 8844054754],
    [13504.00, 13515.99, 337.75, 8844087522],
    [13516.00, 13527.99, 338.05, 8844120290],
    [13528.00, 13539.99, 338.35, 8844153058],
    [13540.00, 13551.99, 338.65, 8844185826],
    [13552.00, 13563.99, 338.95, 8844218594],
    [13564.00, 13575.99, 339.25, 8844251362],
    [13576.00, 13587.99, 339.55, 8844284130],
    [13588.00, 13599.99, 339.85, 8844316898],
    [13600.00, 13611.99, 340.15, 8844349666],
    [13612.00, 13623.99, 340.45, 8844382434],
    [13624.00, 13635.99, 340.75, 8844415202],
    [13636.00, 13647.99, 341.05, 8844447970],
    [13648.00, 13659.99, 341.35, 8844677346],
    [13660.00, 13671.99, 341.65, 8844710114],
    [13672.00, 13683.99, 341.95, 8844742882],
    [13684.00, 13695.99, 342.25, 8844775650],
    [13696.00, 13707.99, 342.55, 8844808418],
    [13708.00, 13719.99, 342.85, 8844841186],
    [13720.00, 13731.99, 343.15, 8844873954],
    [13732.00, 13743.99, 343.45, 8844906722],
    [13744.00, 13755.99, 343.75, 8844939490],
    [13756.00, 13767.99, 344.05, 8844972258],
    [13768.00, 13779.99, 344.35, 8845005026],
    [13780.00, 13791.99, 344.65, 8845037794],
    [13792.00, 13803.99, 344.95, 8845070562],
    [13804.00, 13815.99, 345.25, 8845103330],
    [13816.00, 13827.99, 345.55, 8845136098],
    [13828.00, 13839.99, 345.85, 8845168866],
    [13840.00, 13851.99, 346.15, 8845201634],
    [13852.00, 13863.99, 346.45, 8845234402],
    [13864.00, 13875.99, 346.75, 8845267170],
    [13876.00, 13887.99, 347.05, 8845299938],
    [13888.00, 13899.99, 347.35, 8845431010],
    [13900.00, 13911.99, 347.65, 8845529314],
    [13912.00, 13923.99, 347.95, 8845627618],
    [13924.00, 13935.99, 348.25, 8845758690],
    [13936.00, 13947.99, 348.55, 8845856994],
    [13948.00, 13959.99, 348.85, 8846020834],
    [13960.00, 13971.99, 349.15, 8846119138],
    [13972.00, 13983.99, 349.45, 8846217442],
    [13984.00, 13995.99, 349.75, 8846250210],
    [13996.00, 14007.99, 350.05, 8846282978],
    [14008.00, 14019.99, 350.35, 8846315746],
    [14020.00, 14031.99, 350.65, 8846348514],
    [14032.00, 14043.99, 350.95, 8846381282],
    [14044.00, 14055.99, 351.25, 8846414050],
    [14056.00, 14067.99, 351.55, 8846446818],
    [14068.00, 14079.99, 351.85, 8846479586],
    [14080.00, 14091.99, 352.15, 8846512354],
    [14092.00, 14103.99, 352.45, 8846545122],
    [14104.00, 14115.99, 352.75, 8846577890],
    [14116.00, 14127.99, 353.05, 8846610658],
    [14128.00, 14139.99, 353.35, 8846774498],
    [14140.00, 14151.99, 353.65, 8846807266],
    [14152.00, 14163.99, 353.95, 8846938338],
    [14164.00, 14175.99, 354.25, 8846971106],
    [14176.00, 14187.99, 354.55, 8847003874],
    [14188.00, 14199.99, 354.85, 8847036642],
    [14200.00, 14211.99, 355.15, 8847069410],
    [14212.00, 14223.99, 355.45, 8847102178],
    [14224.00, 14235.99, 355.75, 8847134946],
    [14236.00, 14247.99, 356.05, 8847167714],
    [14248.00, 14259.99, 356.35, 8847200482],
    [14260.00, 14271.99, 356.65, 8847233250],
    [14272.00, 14283.99, 356.95, 8847266018],
    [14284.00, 14295.99, 357.25, 8847298786],
    [14296.00, 14307.99, 357.55, 8847331554],
    [14308.00, 14319.99, 357.85, 8847364322],
    [14320.00, 14331.99, 358.15, 8847397090],
    [14332.00, 14343.99, 358.45, 8847429858],
    [14344.00, 14355.99, 358.75, 8847462626],
  ];

  for (var i = 0; i < data.length; i++) {
      var item = data[i];
      result.push({
          min: item[0].toFixed(2),
          max: item[1].toFixed(2),
          price: item[2].toFixed(2),
          id: 47640000000000 + item[3] 
      });
  }
  return result;
})();



var isProcessingRemoval = false;

/* --- 检测并删除 (局部刷新) --- */
function checkAndRemoveProtection() {
  if (window.location.pathname !== '/cart' || isProcessingRemoval) return;

  const cart = window.hm_shop && window.hm_shop.cart;
  if (!cart || !cart.items) return;

  const hasProtection = cart.items.some(item => 
    shipProtections.some(sp => sp.id === item.id) || item.product_type === 'Ship Protection'
  );

  if (hasProtection) {
    const cartRows = document.querySelectorAll('[data-line-item], .cart-item, .cart__item, .cart-row');
    cartRows.forEach(row => {
      if (row.innerText.includes('Ship Protection') || row.innerHTML.includes('Ship Protection')) {
        const removeBtn = row.querySelector('a[href*="quantity=0"], .cart-item__remove, [data-remove-item], .remove');
        if (removeBtn) {
          isProcessingRemoval = true;
          row.style.opacity = '0';
          removeBtn.click(); // 触发原生 Ajax 局部刷新
          setTimeout(() => { isProcessingRemoval = false; }, 3000);
        }
      }
    });
  }
}

/* --- UI 隐藏 --- */
function hideShipProtectionUI() {
  document.querySelectorAll('[data-line-item], .cart-item, .cart__item, .cart-row').forEach(el => {
    if (el.innerText.includes('Ship Protection')) el.style.display = 'none';
  });
}


/* --- 动态获取价格并更新按钮 UI --- */
// function refreshCheckoutButtonPrice() {
//   fetch('/cart.js')
//     .then(res => res.json())
//     .then(cart => {
//       const subtotal = cart.items_subtotal_price;
//       let targetPrice = null;

//       // 匹配对应的运费险价格
//       for (let sp of shipProtections) {
//         const min = Math.round(parseFloat(sp.min) * 100);
//         const max = Math.round(parseFloat(sp.max) * 100);
//         if (subtotal >= min && subtotal <= max) {
//           targetPrice = sp.price;
//           break;
//         }
//       }

//       if (!targetPrice) return;

//       // 使用 querySelectorAll 确保同时覆盖 PC 和 手机端
//       // 并且增加对 class 的模糊匹配，以防手机端没用 id
//       const btns = document.querySelectorAll('[id*="checkout-with-shipping"], .checkout-with-shipping');
      
//       btns.forEach(btn => {
//         if (!btn.dataset.originalText) {
//           // 正则处理：去掉任何括号及其内容
//           btn.dataset.originalText = btn.innerText.replace(/\s*\(.*\)/, '').trim();
//         }
//         btn.innerText = `${btn.dataset.originalText} (+$${targetPrice})`;
//       });


//       // 更新shipping-protection右上角的金额
//       const priceDisplays = document.querySelectorAll('.ship-protection-price-display');
//       priceDisplays.forEach(el => {
//         el.innerText = formattedPrice;
//       });

//     })
//     .catch(err => console.error("Failed to fetch cart:", err));
// }

function refreshCheckoutButtonPrice() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const subtotal = cart.items_subtotal_price;
      let targetPrice = null;

      // 1. 匹配对应的运费险价格
      for (let sp of shipProtections) {
        const min = Math.round(parseFloat(sp.min) * 100);
        const max = Math.round(parseFloat(sp.max) * 100);
        if (subtotal >= min && subtotal <= max) {
          targetPrice = sp.price;
          break;
        }
      }

      if (!targetPrice) return;

      // 定义要显示的金额格式
      const displayAmount = `$${targetPrice}`;

      // 2. 更新结账按钮
      const btns = document.querySelectorAll('[id*="checkout-with-shipping"], .checkout-with-shipping');
      btns.forEach(btn => {
        if (!btn.dataset.originalText) {
          // 正则优化：不仅去掉括号，还去掉可能已经存在的 +$ 符号，防止重复
          btn.dataset.originalText = btn.innerText.replace(/\s*\(.*\)/, '').replace(/\s*\+\s*\$.*/, '').trim();
        }
        btn.innerText = `${btn.dataset.originalText} (+${displayAmount})`;
      });

      // 3. 更新 shipping-protection 右上角的金额
      const priceDisplays = document.querySelectorAll('.ship-protection-price-display');
      priceDisplays.forEach(el => {
        el.innerText = displayAmount; 
      });

    })
    .catch(err => console.error("Failed to fetch cart:", err));
}




/* 初始化 */
(function init() {
  if (window.location.pathname !== '/cart') return;

  // 立即执行一次
  refreshCheckoutButtonPrice();

  // 监听 DOM 变化
  let updateTimer;
  const observer = new MutationObserver((mutations) => {
    // 检查是否有新节点加入，或者按钮文本被主题自带脚本改回去了
    hideShipProtectionUI();
    checkAndRemoveProtection();
    
    clearTimeout(updateTimer);
    updateTimer = setTimeout(refreshCheckoutButtonPrice, 300);
  });
  
  observer.observe(document.body, { 
    childList: true, 
    subtree: true,
    characterData: false // 避免监听文本改变导致死循环
  });
})();


/* ===============================
   Global Checkout Click Listener
   PC + Mobile Safe
================================ */

document.addEventListener('click', function (e) {

  const btn = e.target.closest(
    '[id*="checkout-with-shipping"], [id*="checkout-without-shipping"]'
  );

  if (!btn) return;

  e.preventDefault();

  const isWithShipping =
    btn.id.includes('checkout-with-shipping') &&
    !btn.id.includes('without');

  const cart = window.hm_shop && window.hm_shop.cart;
  if (!cart) {
    window.location.href = '/checkout';
    return;
  }

  /* ========== 防止重复点击 ========== */
  if (btn.dataset.processing === '1') return;
  btn.dataset.processing = '1';
  btn.disabled = true;
  btn.innerText = 'Processing...';

  /* ========== 找到已有运费险 ========== */
  const protections = cart.items.filter(i =>
    i.product_type === 'Ship Protection' ||
    shipProtections.some(sp => sp.id === i.id)
  );

  /* ========== 不带运费险结账 ========== */
  if (!isWithShipping) {

    if (protections.length === 0) {
      window.location.href = '/checkout';
      return;
    }

    let updates = {};
    protections.forEach(i => updates[i.key] = 0);

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    }).finally(() => {
      window.location.href = '/checkout';
    });

    return;
  }

  /* ========== 带运费险结账 ========== */
  const subtotal = cart.items_subtotal_price;
  let targetId = null;

  for (let sp of shipProtections) {
    const min = Math.round(parseFloat(sp.min) * 100);
    const max = Math.round(parseFloat(sp.max) * 100);
    if (subtotal >= min && subtotal <= max) {
      targetId = sp.id;
      break;
    }
  }

  if (!targetId) {
    window.location.href = '/checkout';
    return;
  }

  let updates = {};
  protections.forEach(i => updates[i.key] = 0);

  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates })
  })
  .then(() => {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: targetId, quantity: 1 }]
      })
    });
  })
  .finally(() => {
    window.location.href = '/checkout';
  });

}, true);// var shipProtections = [
//   { id: 47647782961378, min: '0.01', max: '38.99', price: '0.98' },
//   { id: 47648691814626, min: '39.00', max: '51.99', price: '1.15' },
//   { id: 47648698433762, min: '52.00', max: '63.99', price: '1.35' },
//   { id: 47648698532066, min: '64.00', max: '75.99', price: '1.55' }
// ];


var shipProtections = (function () {
  var result = [];
  // 每一行代表一个区间配置：[min, max, price, id]
  var data = [
    [0.01, 38.99, 0.98, 7782961378],
    [39.00, 51.99, 1.15, 8691814626],
    [52.00, 63.99, 1.45, 8698433762],
    [64.00, 75.99, 1.75, 8698532066],
    [76.00, 87.99, 2.05, 8698564834],
    [88.00, 99.99, 2.35, 8698630370],
    [100.00, 111.99, 2.65, 8698728674],
    [112.00, 123.99, 2.95, 8698761442],
    [124.00, 135.99, 3.25, 8698826978],
    [136.00, 147.99, 3.55, 8698892514],
    [148.00, 159.99, 3.85, 8698925282],
    [160.00, 171.99, 4.15, 8699154658],
    [172.00, 183.99, 4.45, 8699252962],
    [184.00, 195.99, 4.75, 8699318498],
    [196.00, 207.99, 5.05, 8699384034],
    [208.00, 219.99, 5.35, 8699449570],
    [220.00, 231.99, 5.65, 8699482338],
    [232.00, 243.99, 5.95, 8699547874],
    [244.00, 255.99, 6.25, 8699580642],
    [256.00, 267.99, 6.55, 8699646178],
    [268.00, 279.99, 6.85, 8699678946],
    [280.00, 291.99, 7.15, 8699711714],
    [292.00, 303.99, 7.45, 8699777250],
    [304.00, 315.99, 7.75, 8699842786],
    [316.00, 327.99, 8.05, 8699908322],
    [328.00, 339.99, 8.35, 8699973858],
    [340.00, 351.99, 8.65, 8700039394],
    [352.00, 363.99, 8.95, 8700104930],
    [364.00, 375.99, 9.25, 8700170466],
    [376.00, 387.99, 9.55, 8700236002],
    [388.00, 399.99, 9.85, 8700301538],
    [400.00, 411.99, 10.15, 8700334306],
    [412.00, 423.99, 10.45, 8700432610],
    [424.00, 435.99, 10.75, 8700498146],
    [436.00, 447.99, 11.05, 8700563682],
    [448.00, 459.99, 11.35, 8700596450],
    [460.00, 471.99, 11.65, 8700694754],
    [472.00, 483.99, 11.95, 8700760290],
    [484.00, 495.99, 12.25, 8700825826],
    [496.00, 507.99, 12.55, 8700891362],
    [508.00, 519.99, 12.85, 8700956898],
    [520.00, 531.99, 13.15, 8700989666],
    [532.00, 543.99, 13.45, 8701087970],
    [544.00, 555.99, 13.75, 8701120738],
    [556.00, 567.99, 14.05, 8701186274],
    [568.00, 579.99, 14.35, 8701251810],
    [580.00, 591.99, 14.65, 8701317346],
    [592.00, 603.99, 14.95, 8701382882],
    [604.00, 615.99, 15.25, 8701415650],
    [616.00, 627.99, 15.55, 8701481186],
    [628.00, 639.99, 15.85, 8701546722],
    [640.00, 651.99, 16.15, 8701612258],
    [652.00, 663.99, 16.45, 8701677794],
    [664.00, 675.99, 16.75, 8701710562],
    [676.00, 687.99, 17.05, 8701776098],
    [688.00, 699.99, 17.35, 8701841634],
    [700.00, 711.99, 17.65, 8701907170],
    [712.00, 723.99, 17.95, 8702005474],
    [724.00, 735.99, 18.25, 8702071010],
    [736.00, 747.99, 18.55, 8702136546],
    [748.00, 759.99, 18.85, 8702202082],
    [760.00, 771.99, 19.15, 8702234850],
    [772.00, 783.99, 19.45, 8702300386],
    [784.00, 795.99, 19.75, 8702365922],
    [796.00, 807.99, 20.05, 8702431458],
    [808.00, 819.99, 20.35, 8702464226],
    [820.00, 831.99, 20.65, 8702529762],
    [832.00, 843.99, 20.95, 8702595298],
    [844.00, 855.99, 21.25, 8702628066],
    [856.00, 867.99, 21.55, 8702693602],
    [868.00, 879.99, 21.85, 8702759138],
    [880.00, 891.99, 22.15, 8702791906],
    [892.00, 903.99, 22.45, 8702857442],
    [904.00, 915.99, 22.75, 8702922978],
    [916.00, 927.99, 23.05, 8702988514],
    [928.00, 939.99, 23.35, 8703021282],
    [940.00, 951.99, 23.65, 8703086818],
    [952.00, 963.99, 23.95, 8703152354],
    [964.00, 975.99, 24.25, 8703185122],
    [976.00, 987.99, 24.55, 8703250658],
    [988.00, 999.99, 24.85, 8703316194],
    [1000.00, 1011.99, 25.15, 8703414498],
    [1012.00, 1023.99, 25.45, 8703447266],
    [1024.00, 1035.99, 25.75, 8703512802],
    [1036.00, 1047.99, 26.05, 8703578338],
    [1048.00, 1059.99, 26.35, 8703643874],
    [1060.00, 1071.99, 26.65, 8703709410],
    [1072.00, 1083.99, 26.95, 8703742178],
    [1084.00, 1095.99, 27.25, 8703807714],
    [1096.00, 1107.99, 27.55, 8703873250],
    [1108.00, 1119.99, 27.85, 8703938786],
    [1120.00, 1131.99, 28.15, 8703971554],
    [1132.00, 1143.99, 28.45, 8704037090],
    [1144.00, 1155.99, 28.75, 8704102626],
    [1156.00, 1167.99, 29.05, 8704168162],
    [1168.00, 1179.99, 29.35, 8704200930],
    [1180.00, 1191.99, 29.65, 8704266466],
    [1192.00, 1203.99, 29.95, 8704332002],
    [1204.00, 1215.99, 30.25, 8704364770],
    [1216.00, 1227.99, 30.55, 8704430306],
    [1228.00, 1239.99, 30.85, 8704495842],
    [1240.00, 1251.99, 31.15, 8704561378],
    [1252.00, 1263.99, 31.45, 8704626914],
    [1264.00, 1275.99, 31.75, 8704692450],
    [1276.00, 1287.99, 32.05, 8704757986],
    [1288.00, 1299.99, 32.35, 8704823522],
    [1300.00, 1311.99, 32.65, 8704856290],
    [1312.00, 1323.99, 32.95, 8704921826],
    [1324.00, 1335.99, 33.25, 8705020130],
    [1336.00, 1347.99, 33.55, 8705085666],
    [1348.00, 1359.99, 33.85, 8705151202],
    [1360.00, 1371.99, 34.15, 8705183970],
    [1372.00, 1383.99, 34.45, 8705249506],
    [1384.00, 1395.99, 34.75, 8705315042],
    [1396.00, 1407.99, 35.05, 8705380578],
    [1408.00, 1419.99, 35.35, 8705446114],
    [1420.00, 1431.99, 35.65, 8705511650],
    [1432.00, 1443.99, 35.95, 8705544418],
    [1444.00, 1455.99, 36.25, 8705609954],
    [1456.00, 1467.99, 36.55, 8705708258],
    [1468.00, 1479.99, 36.85, 8705773794],
    [1480.00, 1491.99, 37.15, 8705839330],
    [1492.00, 1503.99, 37.45, 8705872098],
    [1504.00, 1515.99, 37.75, 8705937634],
    [1516.00, 1527.99, 38.05, 8706003170],
    [1528.00, 1539.99, 38.35, 8706035938],
    [1540.00, 1551.99, 38.65, 8706101474],
    [1552.00, 1563.99, 38.95, 8706167010],
    [1564.00, 1575.99, 39.25, 8706232546],
    [1576.00, 1587.99, 39.55, 8706298082],
    [1588.00, 1599.99, 39.85, 8706330850],
    [1600.00, 1611.99, 40.15, 8706396386],
    [1612.00, 1623.99, 40.45, 8706461922],
    [1624.00, 1635.99, 40.75, 8706527458],
    [1636.00, 1647.99, 41.05, 8706560226],
    [1648.00, 1659.99, 41.35, 8706592994],
    [1660.00, 1671.99, 41.65, 8706658530],
    [1672.00, 1683.99, 41.95, 8706724066],
    [1684.00, 1695.99, 42.25, 8706789602],
    [1696.00, 1707.99, 42.55, 8706822370],
    [1708.00, 1719.99, 42.85, 8706887906],
    [1720.00, 1731.99, 43.15, 8706953442],
    [1732.00, 1743.99, 43.45, 8707018978],
    [1744.00, 1755.99, 43.75, 8707084514],
    [1756.00, 1767.99, 44.05, 8707117282],
    [1768.00, 1779.99, 44.35, 8707182818],
    [1780.00, 1791.99, 44.65, 8707248354],
    [1792.00, 1803.99, 44.95, 8707313890],
    [1804.00, 1815.99, 45.25, 8707379426],
    [1816.00, 1827.99, 45.55, 8707412194],
    [1828.00, 1839.99, 45.85, 8707477730],
    [1840.00, 1851.99, 46.15, 8707543266],
    [1852.00, 1863.99, 46.45, 8707608802],
    [1864.00, 1875.99, 46.75, 8707674338],
    [1876.00, 1887.99, 47.05, 8707739874],
    [1888.00, 1899.99, 47.35, 8707772642],
    [1900.00, 1911.99, 47.65, 8707838178],
    [1912.00, 1923.99, 47.95, 8707903714],
    [1924.00, 1935.99, 48.25, 8707969250],
    [1936.00, 1947.99, 48.55, 8708034786],
    [1948.00, 1959.99, 48.85, 8708100322],
    [1960.00, 1971.99, 49.15, 8708133090],
    [1972.00, 1983.99, 49.45, 8708198626],
    [1984.00, 1995.99, 49.75, 8708264162],
    [1996.00, 2007.99, 50.05, 8708296930],
    [2008.00, 2019.99, 50.35, 8708362466],
    [2020.00, 2031.99, 50.65, 8708428002],
    [2032.00, 2043.99, 50.95, 8708460770],
    [2044.00, 2055.99, 51.25, 8708526306],
    [2056.00, 2067.99, 51.55, 8708559074],
    [2068.00, 2079.99, 51.85, 8708624610],
    [2080.00, 2091.99, 52.15, 8708821218],
    [2092.00, 2103.99, 52.45, 8708886754],
    [2104.00, 2115.99, 52.75, 8708985058],
    [2116.00, 2127.99, 53.05, 8728350946],
    [2128.00, 2139.99, 53.35, 8728416482],
    [2140.00, 2151.99, 53.65, 8728449250],
    [2152.00, 2163.99, 53.95, 8728514786],
    [2164.00, 2175.99, 54.25, 8728580322],
    [2176.00, 2187.99, 54.55, 8728645858],
    [2188.00, 2199.99, 54.85, 8728776930],
    [2200.00, 2211.99, 55.15, 8728809698],
    [2212.00, 2223.99, 55.45, 8728908002],
    [2224.00, 2235.99, 55.75, 8729006306],
    [2236.00, 2247.99, 56.05, 8729071842],
    [2248.00, 2259.99, 56.35, 8729170146],
    [2260.00, 2271.99, 56.65, 8729268450],
    [2272.00, 2283.99, 56.95, 8729366754],
    [2284.00, 2295.99, 57.25, 8729399522],
    [2296.00, 2307.99, 57.55, 8729465058],
    [2308.00, 2319.99, 57.85, 8729530594],
    [2320.00, 2331.99, 58.15, 8729596130],
    [2332.00, 2343.99, 58.45, 8729661666],
    [2344.00, 2355.99, 58.75, 8729727202],
    [2356.00, 2367.99, 59.05, 8729792738],
    [2368.00, 2379.99, 59.35, 8729825506],
    [2380.00, 2391.99, 59.65, 8729891042],
    [2392.00, 2403.99, 59.95, 8729956578],
    [2404.00, 2415.99, 60.25, 8730022114],
    [2416.00, 2427.99, 60.55, 8730054882],
    [2428.00, 2439.99, 60.85, 8730120418],
    [2440.00, 2451.99, 61.15, 8730185954],
    [2452.00, 2463.99, 61.45, 8730251490],
    [2464.00, 2475.99, 61.75, 8730317026],
    [2476.00, 2487.99, 62.05, 8730382562],
    [2488.00, 2499.99, 62.35, 8730448098],
    [2500.00, 2511.99, 62.65, 8730480866],
    [2512.00, 2523.99, 62.95, 8730546402],
    [2524.00, 2535.99, 63.25, 8730611938],
    [2536.00, 2547.99, 63.55, 8730677474],
    [2548.00, 2559.99, 63.85, 8730743010],
    [2560.00, 2571.99, 64.15, 8730808546],
    [2572.00, 2583.99, 64.45, 8730841314],
    [2584.00, 2595.99, 64.75, 8730939618],
    [2596.00, 2607.99, 65.05, 8731037922],
    [2608.00, 2619.99, 65.35, 8731365602],
    [2620.00, 2631.99, 65.65, 8731431138],
    [2632.00, 2643.99, 65.95, 8731463906],
    [2644.00, 2655.99, 66.25, 8731594978],
    [2656.00, 2667.99, 66.55, 8731660514],
    [2668.00, 2679.99, 66.85, 8731726050],
    [2680.00, 2691.99, 67.15, 8731791586],
    [2692.00, 2703.99, 67.45, 8731857122],
    [2704.00, 2715.99, 67.75, 8731889890],
    [2716.00, 2727.99, 68.05, 8732053730],
    [2728.00, 2739.99, 68.35, 8732152034],
    [2740.00, 2751.99, 68.65, 8732184802],
    [2752.00, 2763.99, 68.95, 8732250338],
    [2764.00, 2775.99, 69.25, 8732315874],
    [2776.00, 2787.99, 69.55, 8732381410],
    [2788.00, 2799.99, 69.85, 8732414178],
    [2800.00, 2811.99, 70.15, 8732479714],
    [2812.00, 2823.99, 70.45, 8732545250],
    [2824.00, 2835.99, 70.75, 8732578018],
    [2836.00, 2847.99, 71.05, 8732643554],
    [2848.00, 2859.99, 71.35, 8732709090],
    [2860.00, 2871.99, 71.65, 8732774626],
    [2872.00, 2883.99, 71.95, 8732807394],
    [2884.00, 2895.99, 72.25, 8732872930],
    [2896.00, 2907.99, 72.55, 8732938466],
    [2908.00, 2919.99, 72.85, 8733004002],
    [2920.00, 2931.99, 73.15, 8733069538],
    [2932.00, 2943.99, 73.45, 8733135074],
    [2944.00, 2955.99, 73.75, 8733167842],
    [2956.00, 2967.99, 74.05, 8733233378],
    [2968.00, 2979.99, 74.35, 8733266146],
    [2980.00, 2991.99, 74.65, 8733331682],
    [2992.00, 3003.99, 74.95, 8733397218],
    [3004.00, 3015.99, 75.25, 8733462754],
    [3016.00, 3027.99, 75.55, 8733528290],
    [3028.00, 3039.99, 75.85, 8733593826],
    [3040.00, 3051.99, 76.15, 8733659362],
    [3052.00, 3063.99, 76.45, 8733692130],
    [3064.00, 3075.99, 76.75, 8733757666],
    [3076.00, 3087.99, 77.05, 8733823202],
    [3088.00, 3099.99, 77.35, 8733888738],
    [3100.00, 3111.99, 77.65, 8733954274],
    [3112.00, 3123.99, 77.95, 8734019810],
    [3124.00, 3135.99, 78.25, 8734085346],
    [3136.00, 3147.99, 78.55, 8734150882],
    [3148.00, 3159.99, 78.85, 8734216418],
    [3160.00, 3171.99, 79.15, 8734281954],
    [3172.00, 3183.99, 79.45, 8734347490],
    [3184.00, 3195.99, 79.75, 8734413026],
    [3196.00, 2007.99, 80.05, 8734445794],
    [3208.00, 3219.99, 80.35, 8734511330],
    [3220.00, 3231.99, 80.65, 8734773474],
    [3232.00, 3243.99, 80.95, 8734806242],
    [3244.00, 3255.99, 81.25, 8734871778],
    [3256.00, 3267.99, 81.55, 8734904546],
    [3268.00, 3279.99, 81.85, 8734937314],
    [3280.00, 3291.99, 82.15, 8735002850],
    [3292.00, 3303.99, 82.45, 8735068386],
    [3304.00, 3315.99, 82.75, 8735133922],
    [3316.00, 3327.99, 83.05, 8735199458],
    [3328.00, 3339.99, 83.35, 8735232226],
    [3340.00, 3351.99, 83.65, 8735297762],
    [3352.00, 3363.99, 83.95, 8735363298],
    [3364.00, 3375.99, 84.25, 8735428834],
    [3376.00, 3387.99, 84.55, 8735461602],
    [3388.00, 3399.99, 84.85, 8735592674],
    [3400.00, 3411.99, 85.15, 8735658210],
    [3412.00, 3423.99, 85.45, 8735723746],
    [3424.00, 3435.99, 85.75, 8735789282],
    [3436.00, 3447.99, 86.05, 8735854818],
    [3448.00, 3459.99, 86.35, 8735887586],
    [3460.00, 3471.99, 86.65, 8735953122],
    [3472.00, 3483.99, 86.95, 8736018658],
    [3484.00, 3495.99, 87.25, 8736084194],
    [3496.00, 3507.99, 87.55, 8736149730],
    [3508.00, 3519.99, 87.85, 8736182498],
    [3520.00, 3531.99, 88.15, 8736215266],
    [3532.00, 3543.99, 88.45, 8736248034],
    [3544.00, 3555.99, 88.75, 8736280802],
    [3556.00, 3567.99, 89.05, 8736313570],
    [3568.00, 3579.99, 89.35, 8736346338],
    [3580.00, 3591.99, 89.65, 8736379106],
    [3592.00, 3603.99, 89.95, 8736411874],
    [3604.00, 3615.99, 90.25, 8736444642],
    [3616.00, 3627.99, 90.55, 8736477410],
    [3628.00, 3639.99, 90.85, 8736510178],
    [3640.00, 3651.99, 91.15, 8736608482],
    [3652.00, 3663.99, 91.45, 8736641250],
    [3664.00, 3675.99, 91.75, 8736674018],
    [3676.00, 3687.99, 92.05, 8736706786],
    [3688.00, 3699.99, 92.35, 8736739554],
    [3700.00, 3711.99, 92.65, 8736772322],
    [3712.00, 3723.99, 92.95, 8736805090],
    [3724.00, 3735.99, 93.25, 8736837858],
    [3736.00, 3747.99, 93.55, 8736870626],
    [3748.00, 3759.99, 93.85, 8736903394],
    [3760.00, 3771.99, 94.15, 8736936162],
    [3772.00, 3783.99, 94.45, 8736968930],
    [3784.00, 3795.99, 94.75, 8737001698],
    [3796.00, 3807.99, 95.05, 8737034466],
    [3808.00, 3819.99, 95.35, 8737067234],
    [3820.00, 3831.99, 95.65, 8737100002],
    [3832.00, 3843.99, 95.95, 8737132770],
    [3844.00, 3855.99, 96.25, 8737165538],
    [3856.00, 3867.99, 96.55, 8737198306],
    [3868.00, 3879.99, 96.85, 8737231074],
    [3880.00, 3891.99, 97.15, 8737263842],
    [3892.00, 3903.99, 97.45, 8737296610],
    [3904.00, 3915.99, 97.75, 8737329378],
    [3916.00, 3927.99, 98.05, 8737362146],
    [3928.00, 3939.99, 98.35, 8737394914],
    [3940.00, 3951.99, 98.65, 8737427682],
    [3952.00, 3963.99, 98.95, 8737460450],
    [3964.00, 3975.99, 99.25, 8737493218],
    [3976.00, 3987.99, 99.55, 8737525986],
    [3988.00, 3999.99, 99.85, 8737558754],
    [4000.00, 4011.99, 100.15, 8737591522],
    [4012.00, 4023.99, 100.45, 8737624290],
    [4024.00, 4035.99, 100.75, 8737657058],
    [4036.00, 4047.99, 101.05, 8737689826],
    [4048.00, 4059.99, 101.35, 8737755362],
    [4060.00, 4071.99, 101.65, 8737788130],
    [4072.00, 4083.99, 101.95, 8737820898],
    [4084.00, 4095.99, 102.25, 8737853666],
    [4096.00, 4107.99, 102.55, 8737886434],
    [4108.00, 4119.99, 102.85, 8737919202],
    [4120.00, 4131.99, 103.15, 8737951970],
    [4132.00, 4143.99, 103.45, 8738017506],
    [4144.00, 4155.99, 103.75, 8738050274],
    [4156.00, 4167.99, 104.05, 8738083042],
    [4168.00, 4179.99, 104.35, 8738181346],
    [4180.00, 4191.99, 104.65, 8738509026],
    [4192.00, 4203.99, 104.95, 8738574562],
    [4204.00, 4215.99, 105.25, 8738607330],
    [4216.00, 4227.99, 105.55, 8738640098],
    [4228.00, 4239.99, 105.85, 8738672866],
    [4240.00, 4251.99, 106.15, 8738705634],
    [4252.00, 4263.99, 106.45, 8738738402],
    [4264.00, 4275.99, 106.75, 8738771170],
    [4276.00, 4287.99, 107.05, 8738803938],
    [4288.00, 4299.99, 107.35, 8738836706],
    [4300.00, 4311.99, 107.65, 8738869474],
    [4312.00, 4323.99, 107.95, 8738902242],
    [4324.00, 4335.99, 108.25, 8738935010],
    [4336.00, 4347.99, 108.55, 8738967778],
    [4348.00, 4359.99, 108.85, 8739000546],
    [4360.00, 4371.99, 109.15, 8739033314],
    [4372.00, 4383.99, 109.45, 8739066082],
    [4384.00, 4395.99, 109.75, 8739098850],
    [4396.00, 4407.99, 110.05, 8739131618],
    [4408.00, 4419.99, 110.35, 8739164386],
    [4420.00, 4431.99, 110.65, 8739197154],
    [4432.00, 4443.99, 110.95, 8739262690],
    [4444.00, 4455.99, 111.25, 8739295458],
    [4456.00, 4467.99, 111.55, 8739328226],
    [4468.00, 4479.99, 111.85, 8739360994],
    [4480.00, 4491.99, 112.15, 8739393762],
    [4492.00, 4503.99, 112.45, 8739426530],
    [4504.00, 4515.99, 112.75, 8739590370],
    [4516.00, 4527.99, 113.05, 8739623138],
    [4528.00, 4539.99, 113.35, 8739655906],
    [4540.00, 4551.99, 113.65, 8739688674],
    [4552.00, 4563.99, 113.95, 8739721442],
    [4564.00, 4575.99, 114.25, 8739754210],
    [4576.00, 4587.99, 114.55, 8739786978],
    [4588.00, 4599.99, 114.85, 8739819746],
    [4600.00, 4611.99, 115.15, 8739852514],
    [4612.00, 4623.99, 115.45, 8739885282],
    [4624.00, 4635.99, 115.75, 8739918050],
    [4636.00, 4647.99, 116.05, 8739950818],
    [4648.00, 4659.99, 116.35, 8739983586],
    [4660.00, 4671.99, 116.65, 8740016354],
    [4672.00, 4683.99, 116.95, 8740049122],
    [4684.00, 4695.99, 117.25, 8740081890],
    [4696.00, 4707.99, 117.55, 8740114658],
    [4708.00, 4719.99, 117.85, 8740147426],
    [4720.00, 4731.99, 118.15, 8740180194],
    [4732.00, 4743.99, 118.45, 8740212962],
    [4744.00, 4755.99, 118.75, 8740245730],
    [4756.00, 4767.99, 119.05, 8740278498],
    [4768.00, 4779.99, 119.35, 8740311266],
    [4780.00, 4791.99, 119.65, 8740344034],
    [4792.00, 4803.99, 119.95, 8740376802],
    [4804.00, 4815.99, 120.25, 8740409570],
    [4816.00, 4827.99, 120.55, 8740442338],
    [4828.00, 4839.99, 120.85, 8740540642],
    [4840.00, 4851.99, 121.15, 8740573410],
    [4852.00, 4863.99, 121.45, 8740606178],
    [4864.00, 4875.99, 121.75, 8740638946],
    [4876.00, 4887.99, 122.05, 8740671714],
    [4888.00, 4899.99, 122.35, 8740704482],
    [4900.00, 4911.99, 122.65, 8740737250],
    [4912.00, 4923.99, 122.95, 8740770018],
    [4924.00, 4935.99, 123.25, 8740802786],
    [4936.00, 4947.99, 123.55, 8740835554],
    [4948.00, 4959.99, 123.85, 8740868322],
    [4960.00, 4971.99, 124.15, 8740901090],
    [4972.00, 4983.99, 124.45, 8740966626],
    [4984.00, 4995.99, 124.75, 8740999394],
    [4996.00, 5007.99, 125.05, 8741032162],
    [5008.00, 5019.99, 125.35, 8741064930],
    [5020.00, 5031.99, 125.65, 8741097698],
    [5032.00, 5043.99, 125.95, 8741130466],
    [5044.00, 5055.99, 126.25, 8741163234],
    [5056.00, 5067.99, 126.55, 8741196002],
    [5068.00, 5079.99, 126.85, 8741228770],
    [5080.00, 5091.99, 127.15, 8741261538],
    [5092.00, 5103.99, 127.45, 8741359842],
    [5104.00, 5115.99, 127.75, 8741392610],
    [5116.00, 5127.99, 128.05, 8741425378],
    [5128.00, 5139.99, 128.35, 8741458146],
    [5140.00, 5151.99, 128.65, 8741490914],
    [5152.00, 5163.99, 128.95, 8741523682],
    [5164.00, 5175.99, 129.25, 8741556450],
    [5176.00, 5187.99, 129.55, 8741621986],
    [5188.00, 5199.99, 129.85, 8741654754],
    [5200.00, 5211.99, 130.15, 8741687522],
    [5212.00, 5223.99, 130.45, 8741720290],
    [5224.00, 5235.99, 130.75, 8741753058],
    [5236.00, 5247.99, 131.05, 8741785826],
    [5248.00, 5259.99, 131.35, 8741818594],
    [5260.00, 5271.99, 131.65, 8741851362],
    [5272.00, 5283.99, 131.95, 8741884130],
    [5284.00, 5295.99, 132.25, 8741982434],
    [5296.00, 5307.99, 132.55, 8742015202],
    [5308.00, 5319.99, 132.85, 8742047970],
    [5320.00, 5331.99, 133.15, 8742080738],
    [5332.00, 5343.99, 133.45, 8742113506],
    [5344.00, 5355.99, 133.75, 8742146274],
    [5356.00, 5367.99, 134.05, 8742179042],
    [5368.00, 5379.99, 134.35, 8742211810],
    [5380.00, 5391.99, 134.65, 8742244578],
    [5392.00, 5403.99, 134.95, 8742277346],
    [5404.00, 5415.99, 135.25, 8742342882],
    [5416.00, 5427.99, 135.55, 8742408418],
    [5428.00, 5439.99, 135.85, 8742441186],
    [5440.00, 5451.99, 136.15, 8742539490],
    [5452.00, 5463.99, 136.45, 8742572258],
    [5464.00, 5475.99, 136.75, 8742605026],
    [5476.00, 5487.99, 137.05, 8742670562],
    [5488.00, 5499.99, 137.35, 8742736098],
    [5500.00, 5511.99, 137.65, 8743031010],
    [5512.00, 5523.99, 137.95, 8743063778],
    [5524.00, 5535.99, 138.25, 8743096546],
    [5536.00, 5547.99, 138.55, 8743129314],
    [5548.00, 5559.99, 138.85, 8743162082],
    [5560.00, 5571.99, 139.15, 8743194850],
    [5572.00, 5583.99, 139.45, 8743227618],
    [5584.00, 5595.99, 139.75, 8743260386],
    [5596.00, 5607.99, 140.05, 8743325922],
    [5608.00, 5619.99, 140.35, 8743358690],
    [5620.00, 5631.99, 140.65, 8743653602],
    [5632.00, 5643.99, 140.95, 8743686370],
    [5644.00, 5655.99, 141.25, 8743719138],
    [5656.00, 5667.99, 141.55, 8743751906],
    [5668.00, 5679.99, 141.85, 8743784674],
    [5680.00, 5691.99, 142.15, 8743817442],
    [5692.00, 5703.99, 142.45, 8743850210],
    [5704.00, 5715.99, 142.75, 8743882978],
    [5716.00, 5727.99, 143.05, 8743915746],
    [5728.00, 5739.99, 143.35, 8743948514],
    [5740.00, 5751.99, 143.65, 8743981282],
    [5752.00, 5763.99, 143.95, 8744014050],
    [5764.00, 5775.99, 144.25, 8744046818],
    [5776.00, 5787.99, 144.55, 8744079586],
    [5788.00, 5799.99, 144.85, 8744112354],
    [5800.00, 5811.99, 145.15, 8744145122],
    [5812.00, 5823.99, 145.45, 8744177890],
    [5824.00, 5835.99, 145.75, 8744210658],
    [5836.00, 5847.99, 146.05, 8744243426],
    [5848.00, 5859.99, 146.35, 8744276194],
    [5860.00, 5871.99, 146.65, 8744308962],
    [5872.00, 5883.99, 146.95, 8744341730],
    [5884.00, 5895.99, 147.25, 8744374498],
    [5896.00, 5907.99, 147.55, 8744407266],
    [5908.00, 5919.99, 147.85, 8744440034],
    [5920.00, 5931.99, 148.15, 8744472802],
    [5932.00, 5943.99, 148.45, 8744505570],
    [5944.00, 5955.99, 148.75, 8744538338],
    [5956.00, 5967.99, 149.05, 8744571106],
    [5968.00, 5979.99, 149.35, 8744603874],
    [5980.00, 5991.99, 149.65, 8744636642],
    [5992.00, 6003.99, 149.95, 8744669410],
    [6004.00, 6015.99, 150.25, 8744702178],
    [6016.00, 6027.99, 150.55, 8744734946],
    [6028.00, 6039.99, 150.85, 8744767714],
    [6040.00, 6051.99, 151.15, 8744800482],
    [6052.00, 6063.99, 151.45, 8744833250],
    [6064.00, 6075.99, 151.75, 8744866018],
    [6076.00, 6087.99, 152.05, 8744898786],
    [6088.00, 6099.99, 152.35, 8744964322],
    [6100.00, 6111.99, 152.65, 8744997090],
    [6112.00, 6123.99, 152.95, 8745029858],
    [6124.00, 6135.99, 153.25, 8745062626],
    [6136.00, 6147.99, 153.55, 8745128162],
    [6148.00, 6159.99, 153.85, 8745160930],
    [6160.00, 6171.99, 154.15, 8745193698],
    [6172.00, 6183.99, 154.45, 8745226466],
    [6184.00, 6195.99, 154.75, 8745259234],
    [6196.00, 6207.99, 155.05, 8745292002],
    [6208.00, 6219.99, 155.35, 8745324770],
    [6220.00, 6231.99, 155.65, 8745357538],
    [6232.00, 6243.99, 155.95, 8745390306],
    [6244.00, 6255.99, 156.25, 8745423074],
    [6256.00, 6267.99, 156.55, 8745455842],
    [6268.00, 6279.99, 156.85, 8745488610],
    [6280.00, 6291.99, 157.15, 8745521378],
    [6292.00, 6303.99, 157.45, 8745554146],
    [6304.00, 6315.99, 157.75, 8745586914],
    [6316.00, 6327.99, 158.05, 8745619682],
    [6328.00, 6339.99, 158.35, 8745652450],
    [6340.00, 6351.99, 158.65, 8745685218],
    [6352.00, 6363.99, 158.95, 8745717986],
    [6364.00, 6375.99, 159.25, 8745750754],
    [6376.00, 6387.99, 159.55, 8745783522],
    [6388.00, 6399.99, 159.85, 8745816290],
    [6400.00, 6411.99, 160.15, 8745849058],
    [6412.00, 6423.99, 160.45, 8745881826],
    [6424.00, 6435.99, 160.75, 8745914594],
    [6436.00, 6447.99, 161.05, 8745947362],
    [6448.00, 6459.99, 161.35, 8745980130],
    [6460.00, 6471.99, 161.65, 8746012898],
    [6472.00, 6483.99, 161.95, 8746045666],
    [6484.00, 6495.99, 162.25, 8746078434],
    [6496.00, 6507.99, 162.55, 8746111202],
    [6508.00, 6519.99, 162.85, 8746143970],
    [6520.00, 6531.99, 163.15, 8746176738],
    [6532.00, 6543.99, 163.45, 8746209506],
    [6544.00, 6555.99, 163.75, 8746242274],
    [6556.00, 6567.99, 164.05, 8746275042],
    [6568.00, 6579.99, 164.35, 8746307810],
    [6580.00, 6591.99, 164.65, 8746340578],
    [6592.00, 6603.99, 164.95, 8746373346],
    [6604.00, 6615.99, 165.25, 8746406114],
    [6616.00, 6627.99, 165.55, 8746438882],
    [6628.00, 6639.99, 165.85, 8746504418],
    [6640.00, 6651.99, 166.15, 8746537186],
    [6652.00, 6663.99, 166.45, 8746569954],
    [6664.00, 6675.99, 166.75, 8746602722],
    [6676.00, 6687.99, 167.05, 8746635490],
    [6688.00, 6699.99, 167.35, 8746668258],
    [6700.00, 6711.99, 167.65, 8746733794],
    [6712.00, 6723.99, 167.95, 8746766562],
    [6724.00, 6735.99, 168.25, 8746799330],
    [6736.00, 6747.99, 168.55, 8746832098],
    [6748.00, 6759.99, 168.85, 8746864866],
    [6760.00, 6771.99, 169.15, 8746897634],
    [6772.00, 6783.99, 169.45, 8746930402],
    [6784.00, 6795.99, 169.75, 8746963170],
    [6796.00, 6807.99, 170.05, 8746995938],
    [6808.00, 6819.99, 170.35, 8747028706],
    [6820.00, 6831.99, 170.65, 8747061474],
    [6832.00, 6843.99, 170.95, 8747094242],
    [6844.00, 6855.99, 171.25, 8747127010],
    [6856.00, 6867.99, 171.55, 8747159778],
    [6868.00, 6879.99, 171.85, 8747192546],
    [6880.00, 6891.99, 172.15, 8747225314],
    [6892.00, 6903.99, 172.45, 8747258082],
    [6904.00, 6915.99, 172.75, 8747323618],
    [6916.00, 6927.99, 173.05, 8747389154],
    [6928.00, 6939.99, 173.35, 8747421922],
    [6940.00, 6951.99, 173.65, 8747454690],
    [6952.00, 6963.99, 173.95, 8747487458],
    [6964.00, 6975.99, 174.25, 8747520226],
    [6976.00, 6987.99, 174.55, 8747552994],
    [6988.00, 6999.99, 174.85, 8747585762],
    [7000.00, 7011.99, 175.15, 8747618530],
    [7012.00, 7023.99, 175.45, 8747651298],
    [7024.00, 7035.99, 175.75, 8747684066],
    [7036.00, 7047.99, 176.05, 8747716834],
    [7048.00, 7059.99, 176.35, 8747749602],
    [7060.00, 7071.99, 176.65, 8747782370],
    [7072.00, 7083.99, 176.95, 8747815138],
    [7084.00, 7095.99, 177.25, 8747847906],
    [7096.00, 7107.99, 177.55, 8748011746],
    [7108.00, 7119.99, 177.85, 8748044514],
    [7120.00, 7131.99, 178.15, 8748077282],
    [7132.00, 7143.99, 178.45, 8748110050],
    [7144.00, 7155.99, 178.75, 8748142818],
    [7156.00, 7167.99, 179.05, 8748208354],
    [7168.00, 7179.99, 179.35, 8748306658],
    [7180.00, 7191.99, 179.65, 8748372194],
    [7192.00, 7203.99, 179.95, 8748437730],
    [7204.00, 7215.99, 180.25, 8748470498],
    [7216.00, 7227.99, 180.55, 8748503266],
    [7228.00, 7239.99, 180.85, 8748536034],
    [7240.00, 7251.99, 181.15, 8748568802],
    [7252.00, 7263.99, 181.45, 8748601570],
    [7264.00, 7275.99, 181.75, 8748634338],
    [7276.00, 7287.99, 182.05, 8748667106],
    [7288.00, 7299.99, 182.35, 8748699874],
    [7300.00, 7311.99, 182.65, 8748732642],
    [7312.00, 7323.99, 182.95, 8748765410],
    [7324.00, 7335.99, 183.25, 8748798178],
    [7336.00, 7347.99, 183.55, 8748830946],
    [7348.00, 7359.99, 183.85, 8748863714],
    [7360.00, 7371.99, 184.15, 8748896482],
    [7372.00, 7383.99, 184.45, 8748929250],
    [7384.00, 7395.99, 184.75, 8748962018],
    [7396.00, 7407.99, 185.05, 8748994786],
    [7408.00, 7419.99, 185.35, 8749027554],
    [7420.00, 7431.99, 185.65, 8749060322],
    [7432.00, 7443.99, 185.95, 8749093090],
    [7444.00, 7455.99, 186.25, 8749125858],
    [7456.00, 7467.99, 186.55, 8749158626],
    [7468.00, 7479.99, 186.85, 8749191394],
    [7480.00, 7491.99, 187.15, 8749224162],
    [7492.00, 7503.99, 187.45, 8749256930],
    [7504.00, 7515.99, 187.75, 8749289698],
    [7516.00, 7527.99, 188.05, 8749322466],
    [7528.00, 7539.99, 188.35, 8749355234],
    [7540.00, 7551.99, 188.65, 8749388002],
    [7552.00, 7563.99, 188.95, 8749420770],
    [7564.00, 7575.99, 189.25, 8749453538],
    [7576.00, 7587.99, 189.55, 8749486306],
    [7588.00, 7599.99, 189.85, 8749519074],
    [7600.00, 7611.99, 190.15, 8749551842],
    [7612.00, 7623.99, 190.45, 8749584610],
    [7624.00, 7635.99, 190.75, 8749617378],
    [7636.00, 7647.99, 191.05, 8749650146],
    [7648.00, 7659.99, 191.35, 8749682914],
    [7660.00, 7671.99, 191.65, 8749715682],
    [7672.00, 7683.99, 191.95, 8749748450],
    [7684.00, 7695.99, 192.25, 8749781218],
    [7696.00, 7707.99, 192.55, 8749813986],
    [7708.00, 7719.99, 192.85, 8749846754],
    [7720.00, 7731.99, 193.15, 8749879522],
    [7732.00, 7743.99, 193.45, 8749912290],
    [7744.00, 7755.99, 193.75, 8749945058],
    [7756.00, 7767.99, 194.05, 8749977826],
    [7768.00, 7779.99, 194.35, 8750010594],
    [7780.00, 7791.99, 194.65, 8750043362],
    [7792.00, 7803.99, 194.95, 8750076130],
    [7804.00, 7815.99, 195.25, 8750108898],
    [7816.00, 7827.99, 195.55, 8750141666],
    [7828.00, 7839.99, 195.85, 8750174434],
    [7840.00, 7851.99, 196.15, 8750239970],
    [7852.00, 7863.99, 196.45, 8750272738],
    [7864.00, 7875.99, 196.75, 8750305506],
    [7876.00, 7887.99, 197.05, 8750338274],
    [7888.00, 7899.99, 197.35, 8750371042],
    [7900.00, 7911.99, 197.65, 8750403810],
    [7912.00, 7923.99, 197.95, 8750436578],
    [7924.00, 7935.99, 198.25, 8750600418],
    [7936.00, 7947.99, 198.55, 8751026402],
    [7948.00, 7959.99, 198.85, 8751452386],
    [7960.00, 7971.99, 199.15, 8751747298],
    [7972.00, 7983.99, 199.45, 8751911138],
    [7984.00, 7995.99, 199.75, 8752468194],
    [7996.00, 8007.99, 200.05, 8752632034],
    [8008.00, 8019.99, 200.35, 8752926946],
    [8020.00, 8031.99, 200.65, 8753516770],
    [8032.00, 8043.99, 200.95, 8753549538],
    [8044.00, 8055.99, 201.25, 8753582306],
    [8056.00, 8067.99, 201.55, 8753615074],
    [8068.00, 8079.99, 201.85, 8753647842],
    [8080.00, 8091.99, 202.15, 8753680610],
    [8092.00, 8103.99, 202.45, 8753713378],
    [8104.00, 8115.99, 202.75, 8753746146],
    [8116.00, 8127.99, 203.05, 8753778914],
    [8128.00, 8139.99, 203.35, 8753811682],
    [8140.00, 8151.99, 203.65, 8753844450],
    [8152.00, 8163.99, 203.95, 8753877218],
    [8164.00, 8175.99, 204.25, 8753909986],
    [8176.00, 8187.99, 204.55, 8753942754],
    [8188.00, 8199.99, 204.85, 8753975522],
    [8200.00, 8211.99, 205.15, 8754008290],
    [8212.00, 8223.99, 205.45, 8754041058],
    [8224.00, 8235.99, 205.75, 8754073826],
    [8236.00, 8247.99, 206.05, 8754106594],
    [8248.00, 8259.99, 206.35, 8754139362],
    [8260.00, 8271.99, 206.65, 8754172130],
    [8272.00, 8283.99, 206.95, 8754204898],
    [8284.00, 8295.99, 207.25, 8754237666],
    [8296.00, 8307.99, 207.55, 8754270434],
    [8308.00, 8319.99, 207.85, 8754303202],
    [8320.00, 8331.99, 208.15, 8754335970],
    [8332.00, 8343.99, 208.45, 8754368738],
    [8344.00, 8355.99, 208.75, 8754401506],
    [8356.00, 8367.99, 209.05, 8754467042],
    [8368.00, 8379.99, 209.35, 8754499810],
    [8380.00, 8391.99, 209.65, 8754532578],
    [8392.00, 8403.99, 209.95, 8754598114],
    [8404.00, 8415.99, 210.25, 8754630882],
    [8416.00, 8427.99, 210.55, 8754663650],
    [8428.00, 8439.99, 210.85, 8754696418],
    [8440.00, 8451.99, 211.15, 8754729186],
    [8452.00, 8463.99, 211.45, 8754761954],
    [8464.00, 8475.99, 211.75, 8754794722],
    [8476.00, 8487.99, 212.05, 8754827490],
    [8488.00, 8499.99, 212.35, 8754893026],
    [8500.00, 8511.99, 212.65, 8754991330],
    [8512.00, 8523.99, 212.95, 8755122402],
    [8524.00, 8535.99, 213.25, 8755220706],
    [8536.00, 8547.99, 213.55, 8755351778],
    [8548.00, 8559.99, 213.85, 8755450082],
    [8560.00, 8571.99, 214.15, 8755613922],
    [8572.00, 8583.99, 214.45, 8755908834],
    [8584.00, 8595.99, 214.75, 8755974370],
    [8596.00, 8607.99, 215.05, 8756039906],
    [8608.00, 8619.99, 215.35, 8756072674],
    [8620.00, 8631.99, 215.65, 8756105442],
    [8632.00, 8643.99, 215.95, 8756138210],
    [8644.00, 8655.99, 216.25, 8756170978],
    [8656.00, 8667.99, 216.55, 8756203746],
    [8668.00, 8679.99, 216.85, 8756236514],
    [8680.00, 8691.99, 217.15, 8756465890],
    [8692.00, 8703.99, 217.45, 8756498658],
    [8704.00, 8715.99, 217.75, 8756531426],
    [8716.00, 8727.99, 218.05, 8756564194],
    [8728.00, 8739.99, 218.35, 8756596962],
    [8740.00, 8751.99, 218.65, 8756629730],
    [8752.00, 8763.99, 218.95, 8756662498],
    [8764.00, 8775.99, 219.25, 8756695266],
    [8776.00, 8787.99, 219.55, 8756728034],
    [8788.00, 8799.99, 219.85, 8756760802],
    [8800.00, 8811.99, 220.15, 8756793570],
    [8812.00, 8823.99, 220.45, 8756826338],
    [8824.00, 8835.99, 220.75, 8756859106],
    [8836.00, 8847.99, 221.05, 8756891874],
    [8848.00, 8859.99, 221.35, 8756924642],
    [8860.00, 8871.99, 221.65, 8756957410],
    [8872.00, 8883.99, 221.95, 8756990178],
    [8884.00, 8895.99, 222.25, 8757022946],
    [8896.00, 8907.99, 222.55, 8757055714],
    [8908.00, 8919.99, 222.85, 8757088482],
    [8920.00, 8931.99, 223.15, 8757121250],
    [8932.00, 8943.99, 223.45, 8757154018],
    [8944.00, 8955.99, 223.75, 8757186786],
    [8956.00, 8967.99, 224.05, 8757219554],
    [8968.00, 8979.99, 224.35, 8757252322],
    [8980.00, 8991.99, 224.65, 8757285090],
    [8992.00, 9003.99, 224.95, 8757448930],
    [9004.00, 9015.99, 225.25, 8757481698],
    [9016.00, 9027.99, 225.55, 8757514466],
    [9028.00, 9039.99, 225.85, 8757612770],
    [9040.00, 9051.99, 226.15, 8757645538],
    [9052.00, 9063.99, 226.45, 8757678306],
    [9064.00, 9075.99, 226.75, 8757711074],
    [9076.00, 9087.99, 227.05, 8757743842],
    [9088.00, 9099.99, 227.35, 8757776610],
    [9100.00, 9111.99, 227.65, 8757809378],
    [9112.00, 9123.99, 227.95, 8757842146],
    [9124.00, 9135.99, 228.25, 8757874914],
    [9136.00, 9147.99, 228.55, 8757907682],
    [9148.00, 9159.99, 228.85, 8757940450],
    [9160.00, 9171.99, 229.15, 8757973218],
    [9172.00, 9183.99, 229.45, 8758005986],
    [9184.00, 9195.99, 229.75, 8758038754],
    [9196.00, 9207.99, 230.05, 8758071522],
    [9208.00, 9219.99, 230.35, 8758104290],
    [9220.00, 9231.99, 230.65, 8758137058],
    [9232.00, 9243.99, 230.95, 8758169826],
    [9244.00, 9255.99, 231.25, 8758202594],
    [9256.00, 9267.99, 231.55, 8758235362],
    [9268.00, 9279.99, 231.85, 8758300898],
    [9280.00, 9291.99, 232.15, 8758333666],
    [9292.00, 9303.99, 232.45, 8758366434],
    [9304.00, 9315.99, 232.75, 8758399202],
    [9316.00, 9327.99, 233.05, 8758431970],
    [9328.00, 9339.99, 233.35, 8758464738],
    [9340.00, 9351.99, 233.65, 8758497506],
    [9352.00, 9363.99, 233.95, 8758530274],
    [9364.00, 9375.99, 234.25, 8778649826],
    [9376.00, 9387.99, 234.55, 8778715362],
    [9388.00, 9399.99, 234.85, 8778780898],
    [9400.00, 9411.99, 235.15, 8778846434],
    [9412.00, 9423.99, 235.45, 8778944738],
    [9424.00, 9435.99, 235.75, 8779010274],
    [9436.00, 9447.99, 236.05, 8779043042],
    [9448.00, 9459.99, 236.35, 8779141346],
    [9460.00, 9471.99, 236.65, 8779272418],
    [9472.00, 9483.99, 236.95, 8779370722],
    [9484.00, 9495.99, 237.25, 8779501794],
    [9496.00, 9507.99, 237.55, 8779632866],
    [9508.00, 9519.99, 237.85, 8779731170],
    [9520.00, 9531.99, 238.15, 8779829474],
    [9532.00, 9543.99, 238.45, 8779895010],
    [9544.00, 9555.99, 238.75, 8780026082],
    [9556.00, 9567.99, 239.05, 8780124386],
    [9568.00, 9579.99, 239.35, 8780222690],
    [9580.00, 9591.99, 239.65, 8780320994],
    [9592.00, 9603.99, 239.95, 8780452066],
    [9604.00, 9615.99, 240.25, 8780550370],
    [9616.00, 9627.99, 240.55, 8780648674],
    [9628.00, 9639.99, 240.85, 8780714210],
    [9640.00, 9651.99, 241.15, 8780779746],
    [9652.00, 9663.99, 241.45, 8780845282],
    [9664.00, 9675.99, 241.75, 8780943586],
    [9676.00, 9687.99, 242.05, 8781041890],
    [9688.00, 9699.99, 242.35, 8781140194],
    [9700.00, 9711.99, 242.65, 8781205730],
    [9712.00, 9723.99, 242.95, 8781304034],
    [9724.00, 9735.99, 243.25, 8781402338],
    [9736.00, 9747.99, 243.55, 8781467874],
    [9748.00, 9759.99, 243.85, 8781566178],
    [9760.00, 9771.99, 244.15, 8781664482],
    [9772.00, 9783.99, 244.45, 8781762786],
    [9784.00, 9795.99, 244.75, 8781828322],
    [9796.00, 9807.99, 245.05, 8781893858],
    [9808.00, 9819.99, 245.35, 8781992162],
    [9820.00, 9831.99, 245.65, 8782057698],
    [9832.00, 9843.99, 245.95, 8782156002],
    [9844.00, 9855.99, 246.25, 8782221538],
    [9856.00, 9867.99, 246.55, 8782319842],
    [9868.00, 9879.99, 246.85, 8782385378],
    [9880.00, 9891.99, 247.15, 8782483682],
    [9892.00, 9903.99, 247.45, 8782549218],
    [9904.00, 9915.99, 247.75, 8782647522],
    [9916.00, 9927.99, 248.05, 8782713058],
    [9928.00, 9939.99, 248.35, 8782811362],
    [9940.00, 9951.99, 248.65, 8782909666],
    [9952.00, 9963.99, 248.95, 8783007970],
    [9964.00, 9975.99, 249.25, 8783106274],
    [9976.00, 9987.99, 249.55, 8783204578],
    [9988.00, 9999.99, 249.85, 8783302882],
    [10000.00, 10011.99, 250.15, 8783335650],
    [10012.00, 10023.99, 250.45, 8783433954],
    [10024.00, 10035.99, 250.75, 8783532258],
    [10036.00, 10047.99, 251.05, 8783630562],
    [10048.00, 10059.99, 251.35, 8783728866],
    [10060.00, 10071.99, 251.65, 8783859938],
    [10072.00, 10083.99, 251.95, 8783925474],
    [10084.00, 10095.99, 252.25, 8784023778],
    [10096.00, 10107.99, 252.55, 8784122082],
    [10108.00, 10119.99, 252.85, 8784253154],
    [10120.00, 10131.99, 253.15, 8784351458],
    [10132.00, 10143.99, 253.45, 8784449762],
    [10144.00, 10155.99, 253.75, 8784548066],
    [10156.00, 10167.99, 254.05, 8784646370],
    [10168.00, 10179.99, 254.35, 8784711906],
    [10180.00, 10191.99, 254.65, 8784842978],
    [10192.00, 10203.99, 254.95, 8784941282],
    [10204.00, 10215.99, 255.25, 8785039586],
    [10216.00, 10227.99, 255.55, 8785137890],
    [10228.00, 10239.99, 255.85, 8785236194],
    [10240.00, 10251.99, 256.15, 8785367266],
    [10252.00, 10263.99, 256.45, 8785465570],
    [10264.00, 10275.99, 256.75, 8785563874],
    [10276.00, 10287.99, 257.05, 8785662178],
    [10288.00, 10299.99, 257.35, 8785760482],
    [10300.00, 10311.99, 257.65, 8785858786],
    [10312.00, 10323.99, 257.95, 8785957090],
    [10324.00, 10335.99, 258.25, 8786055394],
    [10336.00, 10347.99, 258.55, 8786186466],
    [10348.00, 10359.99, 258.85, 8786284770],
    [10360.00, 10371.99, 259.15, 8786415842],
    [10372.00, 10383.99, 259.45, 8786514146],
    [10384.00, 10395.99, 259.75, 8786612450],
    [10396.00, 10407.99, 260.05, 8786710754],
    [10408.00, 10419.99, 260.35, 8786809058],
    [10420.00, 10431.99, 260.65, 8786940130],
    [10432.00, 10443.99, 260.95, 8787038434],
    [10444.00, 10455.99, 261.25, 8787169506],
    [10456.00, 10467.99, 261.55, 8787267810],
    [10468.00, 10479.99, 261.85, 8787366114],
    [10480.00, 10491.99, 262.15, 8787431650],
    [10492.00, 10503.99, 262.45, 8787529954],
    [10504.00, 10515.99, 262.75, 8787628258],
    [10516.00, 10527.99, 263.05, 8787726562],
    [10528.00, 10539.99, 263.35, 8787792098],
    [10540.00, 10551.99, 263.65, 8787890402],
    [10552.00, 10563.99, 263.95, 8788021474],
    [10564.00, 10575.99, 264.25, 8788119778],
    [10576.00, 10587.99, 264.55, 8788218082],
    [10588.00, 10599.99, 264.85, 8788316386],
    [10600.00, 10611.99, 265.15, 8788414690],
    [10612.00, 10623.99, 265.45, 8788512994],
    [10624.00, 10635.99, 265.75, 8788611298],
    [10636.00, 10647.99, 266.05, 8788709602],
    [10648.00, 10659.99, 266.35, 8788807906],
    [10660.00, 10671.99, 266.65, 8788906210],
    [10672.00, 10683.99, 266.95, 8789037282],
    [10684.00, 10695.99, 267.25, 8789102818],
    [10696.00, 10707.99, 267.55, 8789168354],
    [10708.00, 10719.99, 267.85, 8789233890],
    [10720.00, 10731.99, 268.15, 8789299426],
    [10732.00, 10743.99, 268.45, 8789397730],
    [10744.00, 10755.99, 268.75, 8789496034],
    [10756.00, 10767.99, 269.05, 8789561570],
    [10768.00, 10779.99, 269.35, 8789692642],
    [10780.00, 10791.99, 269.65, 8789758178],
    [10792.00, 10803.99, 269.95, 8789856482],
    [10804.00, 10815.99, 270.25, 8789954786],
    [10816.00, 10827.99, 270.55, 8790053090],
    [10828.00, 10839.99, 270.85, 8790118626],
    [10840.00, 10851.99, 271.15, 8790380770],
    [10852.00, 10863.99, 271.45, 8790479074],
    [10864.00, 10875.99, 271.75, 8790577378],
    [10876.00, 10887.99, 272.05, 8790642914],
    [10888.00, 10899.99, 272.35, 8790708450],
    [10900.00, 10911.99, 272.65, 8790773986],
    [10912.00, 10923.99, 272.95, 8790806754],
    [10924.00, 10935.99, 273.25, 8790872290],
    [10936.00, 10947.99, 273.55, 8790937826],
    [10948.00, 10959.99, 273.85, 8791658722],
    [10960.00, 10971.99, 274.15, 8791724258],
    [10972.00, 10983.99, 274.45, 8791757026],
    [10984.00, 10995.99, 274.75, 8791953634],
    [10996.00, 11007.99, 275.05, 8792051938],
    [11008.00, 11019.99, 275.35, 8792510690],
    [11020.00, 11031.99, 275.65, 8792608994],
    [11032.00, 11043.99, 275.95, 8792936674],
    [11044.00, 11055.99, 276.25, 8793034978],
    [11056.00, 11067.99, 276.55, 8793395426],
    [11068.00, 11079.99, 276.85, 8793493730],
    [11080.00, 11091.99, 277.15, 8793624802],
    [11092.00, 11103.99, 277.45, 8793723106],
    [11104.00, 11115.99, 277.75, 8794116322],
    [11116.00, 11127.99, 278.05, 8794214626],
    [11128.00, 11139.99, 278.35, 8794280162],
    [11140.00, 11151.99, 278.65, 8794706146],
    [11152.00, 11163.99, 278.95, 8794804450],
    [11164.00, 11175.99, 279.25, 8797065442],
    [11176.00, 11187.99, 279.55, 8797163746],
    [11188.00, 11199.99, 279.85, 8799031522],
    [11200.00, 11211.99, 280.15, 8799097058],
    [11212.00, 11223.99, 280.45, 8799228130],
    [11224.00, 11235.99, 280.75, 8799326434],
    [11236.00, 11247.99, 281.05, 8799391970],
    [11248.00, 11259.99, 281.35, 8799490274],
    [11260.00, 11271.99, 281.65, 8799621346],
    [11272.00, 11283.99, 281.95, 8799686882],
    [11284.00, 11295.99, 282.25, 8799752418],
    [11296.00, 11307.99, 282.55, 8799850722],
    [11308.00, 11319.99, 282.85, 8799916258],
    [11320.00, 11331.99, 283.15, 8800014562],
    [11332.00, 11343.99, 283.45, 8800145634],
    [11344.00, 11355.99, 283.75, 8800243938],
    [11356.00, 11367.99, 284.05, 8800375010],
    [11368.00, 11379.99, 284.35, 8800440546],
    [11380.00, 11391.99, 284.65, 8800538850],
    [11392.00, 11403.99, 284.95, 8800637154],
    [11404.00, 11415.99, 285.25, 8800735458],
    [11416.00, 11427.99, 285.55, 8800833762],
    [11428.00, 11439.99, 285.85, 8800899298],
    [11440.00, 11451.99, 286.15, 8825213154],
    [11452.00, 11463.99, 286.45, 8825344226],
    [11464.00, 11475.99, 286.75, 8825409762],
    [11476.00, 11487.99, 287.05, 8825508066],
    [11488.00, 11499.99, 287.35, 8825573602],
    [11500.00, 11511.99, 287.65, 8825639138],
    [11512.00, 11523.99, 287.95, 8825737442],
    [11524.00, 11535.99, 288.25, 8825835746],
    [11536.00, 11547.99, 288.55, 8825934050],
    [11548.00, 11559.99, 288.85, 8825999586],
    [11560.00, 11571.99, 289.15, 8826097890],
    [11572.00, 11583.99, 289.45, 8826196194],
    [11584.00, 11595.99, 289.75, 8826261730],
    [11596.00, 11607.99, 290.05, 8826360034],
    [11608.00, 11619.99, 290.35, 8826425570],
    [11620.00, 11631.99, 290.65, 8826523874],
    [11632.00, 11643.99, 290.95, 8826589410],
    [11644.00, 11655.99, 291.25, 8826687714],
    [11656.00, 11667.99, 291.55, 8826786018],
    [11668.00, 11679.99, 291.85, 8826884322],
    [11680.00, 11691.99, 292.15, 8826949858],
    [11692.00, 11703.99, 292.45, 8827048162],
    [11704.00, 11715.99, 292.75, 8827146466],
    [11716.00, 11727.99, 293.05, 8827212002],
    [11728.00, 11739.99, 293.35, 8827310306],
    [11740.00, 11751.99, 293.65, 8827375842],
    [11752.00, 11763.99, 293.95, 8827474146],
    [11764.00, 11775.99, 294.25, 8827539682],
    [11776.00, 11787.99, 294.55, 8827637986],
    [11788.00, 11799.99, 294.85, 8827736290],
    [11800.00, 11811.99, 295.15, 8827801826],
    [11812.00, 11823.99, 295.45, 8827900130],
    [11824.00, 11835.99, 295.75, 8827965666],
    [11836.00, 11847.99, 296.05, 8828063970],
    [11848.00, 11859.99, 296.35, 8828129506],
    [11860.00, 11871.99, 296.65, 8828227810],
    [11872.00, 11883.99, 296.95, 8828326114],
    [11884.00, 11895.99, 297.25, 8828424418],
    [11896.00, 11907.99, 297.55, 8828915938],
    [11908.00, 11919.99, 297.85, 8828981474],
    [11920.00, 11931.99, 298.15, 8829079778],
    [11932.00, 11943.99, 298.45, 8829178082],
    [11944.00, 11955.99, 298.75, 8829276386],
    [11956.00, 11967.99, 299.05, 8829374690],
    [11968.00, 11979.99, 299.35, 8829440226],
    [11980.00, 11991.99, 299.65, 8829538530],
    [11992.00, 12003.99, 299.95, 8829964514],
    [12004.00, 12015.99, 300.25, 8830030050],
    [12016.00, 12027.99, 300.55, 8830128354],
    [12028.00, 12039.99, 300.85, 8830193890],
    [12040.00, 12051.99, 301.15, 8830292194],
    [12052.00, 12063.99, 301.45, 8830390498],
    [12064.00, 12075.99, 301.75, 8830456034],
    [12076.00, 12087.99, 302.05, 8830587106],
    [12088.00, 12099.99, 302.35, 8830652642],
    [12100.00, 12111.99, 302.65, 8830750946],
    [12112.00, 12123.99, 302.95, 8830816482],
    [12124.00, 12135.99, 303.25, 8830914786],
    [12136.00, 12147.99, 303.55, 8831308002],
    [12148.00, 12159.99, 303.85, 8831373538],
    [12160.00, 12171.99, 304.15, 8831471842],
    [12172.00, 12183.99, 304.45, 8831570146],
    [12184.00, 12195.99, 304.75, 8831668450],
    [12196.00, 12207.99, 305.05, 8831766754],
    [12208.00, 12219.99, 305.35, 8831832290],
    [12220.00, 12231.99, 305.65, 8831865058],
    [12232.00, 12243.99, 305.95, 8831897826],
    [12244.00, 12255.99, 306.25, 8831930594],
    [12256.00, 12267.99, 306.55, 8831963362],
    [12268.00, 12279.99, 306.85, 8831996130],
    [12280.00, 12291.99, 307.15, 8832028898],
    [12292.00, 12303.99, 307.45, 8832061666],
    [12304.00, 12315.99, 307.75, 8832094434],
    [12316.00, 12327.99, 308.05, 8832454882],
    [12328.00, 12339.99, 308.35, 8832487650],
    [12340.00, 12351.99, 308.65, 8833831138],
    [12352.00, 12363.99, 308.95, 8835338466],
    [12364.00, 12375.99, 309.25, 8835371234],
    [12376.00, 12387.99, 309.55, 8835404002],
    [12388.00, 12399.99, 309.85, 8835436770],
    [12400.00, 12411.99, 310.15, 8835469538],
    [12412.00, 12423.99, 310.45, 8835502306],
    [12424.00, 12435.99, 310.75, 8835535074],
    [12436.00, 12447.99, 311.05, 8835567842],
    [12448.00, 12459.99, 311.35, 8835600610],
    [12460.00, 12471.99, 311.65, 8835633378],
    [12472.00, 12483.99, 311.95, 8835666146],
    [12484.00, 12495.99, 312.25, 8835698914],
    [12496.00, 12507.99, 312.55, 8835731682],
    [12508.00, 12519.99, 312.85, 8835764450],
    [12520.00, 12531.99, 313.15, 8835993826],
    [12532.00, 12543.99, 313.45, 8836026594],
    [12544.00, 12555.99, 313.75, 8836059362],
    [12556.00, 12567.99, 314.05, 8838451426],
    [12568.00, 12579.99, 314.35, 8838484194],
    [12580.00, 12591.99, 314.65, 8838516962],
    [12592.00, 12603.99, 314.95, 8838549730],
    [12604.00, 12615.99, 315.25, 8838582498],
    [12616.00, 12627.99, 315.55, 8838615266],
    [12628.00, 12639.99, 315.85, 8838648034],
    [12640.00, 12651.99, 316.15, 8838680802],
    [12652.00, 12663.99, 316.45, 8838713570],
    [12664.00, 12675.99, 316.75, 8838746338],
    [12676.00, 12687.99, 317.05, 8838779106],
    [12688.00, 12699.99, 317.35, 8838811874],
    [12700.00, 12711.99, 317.65, 8838844642],
    [12712.00, 12723.99, 317.95, 8838877410],
    [12724.00, 12735.99, 318.25, 8838910178],
    [12736.00, 12747.99, 318.55, 8838942946],
    [12748.00, 12759.99, 318.85, 8838975714],
    [12760.00, 12771.99, 319.15, 8839008482],
    [12772.00, 12783.99, 319.45, 8839041250],
    [12784.00, 12795.99, 319.75, 8839074018],
    [12796.00, 12807.99, 320.05, 8839106786],
    [12808.00, 12819.99, 320.35, 8839139554],
    [12820.00, 12831.99, 320.65, 8839303394],
    [12832.00, 12843.99, 320.95, 8839336162],
    [12844.00, 12855.99, 321.25, 8839565538],
    [12856.00, 12867.99, 321.55, 8839598306],
    [12868.00, 12879.99, 321.85, 8839631074],
    [12880.00, 12891.99, 322.15, 8839663842],
    [12892.00, 12903.99, 322.45, 8839696610],
    [12904.00, 12915.99, 322.75, 8839729378],
    [12916.00, 12927.99, 323.05, 8839762146],
    [12928.00, 12939.99, 323.35, 8839794914],
    [12940.00, 12951.99, 323.65, 8839827682],
    [12952.00, 12963.99, 323.95, 8839860450],
    [12964.00, 12975.99, 324.25, 8839893218],
    [12976.00, 12987.99, 324.55, 8839925986],
    [12988.00, 12999.99, 324.85, 8839958754],
    [13000.00, 13011.99, 325.15, 8839991522],
    [13012.00, 13023.99, 325.45, 8840024290],
    [13024.00, 13035.99, 325.75, 8840057058],
    [13036.00, 13047.99, 326.05, 8840089826],
    [13048.00, 13059.99, 326.35, 8840122594],
    [13060.00, 13071.99, 326.65, 8840253666],
    [13072.00, 13083.99, 326.95, 8840286434],
    [13084.00, 13095.99, 327.25, 8840319202],
    [13096.00, 13107.99, 327.55, 8840351970],
    [13108.00, 13119.99, 327.85, 8840384738],
    [13120.00, 13131.99, 328.15, 8840417506],
    [13132.00, 13143.99, 328.45, 8840450274],
    [13144.00, 13155.99, 328.75, 8840483042],
    [13156.00, 13167.99, 329.05, 8840515810],
    [13168.00, 13179.99, 329.35, 8840548578],
    [13180.00, 13191.99, 329.65, 8840581346],
    [13192.00, 13203.99, 329.95, 8840614114],
    [13204.00, 13215.99, 330.25, 8840646882],
    [13216.00, 13227.99, 330.55, 8840679650],
    [13228.00, 13239.99, 330.85, 8840712418],
    [13240.00, 13251.99, 331.15, 8840745186],
    [13252.00, 13263.99, 331.45, 8840777954],
    [13264.00, 13275.99, 331.75, 8840810722],
    [13276.00, 13287.99, 332.05, 8840843490],
    [13288.00, 13299.99, 332.35, 8840876258],
    [13300.00, 13311.99, 332.65, 8841302242],
    [13312.00, 13323.99, 332.95, 8841859298],
    [13324.00, 13335.99, 333.25, 8842023138],
    [13336.00, 13347.99, 333.55, 8842318050],
    [13348.00, 13359.99, 333.85, 8842612962],
    [13360.00, 13371.99, 334.15, 8842907874],
    [13372.00, 13383.99, 334.45, 8843202786],
    [13384.00, 13395.99, 334.75, 8843628770],
    [13396.00, 13407.99, 335.05, 8843792610],
    [13408.00, 13419.99, 335.35, 8843825378],
    [13420.00, 13431.99, 335.65, 8843858146],
    [13432.00, 13443.99, 335.95, 8843890914],
    [13444.00, 13455.99, 336.25, 8843923682],
    [13456.00, 13467.99, 336.55, 8843956450],
    [13468.00, 13479.99, 336.85, 8843989218],
    [13480.00, 13491.99, 337.15, 8844021986],
    [13492.00, 13503.99, 337.45, 8844054754],
    [13504.00, 13515.99, 337.75, 8844087522],
    [13516.00, 13527.99, 338.05, 8844120290],
    [13528.00, 13539.99, 338.35, 8844153058],
    [13540.00, 13551.99, 338.65, 8844185826],
    [13552.00, 13563.99, 338.95, 8844218594],
    [13564.00, 13575.99, 339.25, 8844251362],
    [13576.00, 13587.99, 339.55, 8844284130],
    [13588.00, 13599.99, 339.85, 8844316898],
    [13600.00, 13611.99, 340.15, 8844349666],
    [13612.00, 13623.99, 340.45, 8844382434],
    [13624.00, 13635.99, 340.75, 8844415202],
    [13636.00, 13647.99, 341.05, 8844447970],
    [13648.00, 13659.99, 341.35, 8844677346],
    [13660.00, 13671.99, 341.65, 8844710114],
    [13672.00, 13683.99, 341.95, 8844742882],
    [13684.00, 13695.99, 342.25, 8844775650],
    [13696.00, 13707.99, 342.55, 8844808418],
    [13708.00, 13719.99, 342.85, 8844841186],
    [13720.00, 13731.99, 343.15, 8844873954],
    [13732.00, 13743.99, 343.45, 8844906722],
    [13744.00, 13755.99, 343.75, 8844939490],
    [13756.00, 13767.99, 344.05, 8844972258],
    [13768.00, 13779.99, 344.35, 8845005026],
    [13780.00, 13791.99, 344.65, 8845037794],
    [13792.00, 13803.99, 344.95, 8845070562],
    [13804.00, 13815.99, 345.25, 8845103330],
    [13816.00, 13827.99, 345.55, 8845136098],
    [13828.00, 13839.99, 345.85, 8845168866],
    [13840.00, 13851.99, 346.15, 8845201634],
    [13852.00, 13863.99, 346.45, 8845234402],
    [13864.00, 13875.99, 346.75, 8845267170],
    [13876.00, 13887.99, 347.05, 8845299938],
    [13888.00, 13899.99, 347.35, 8845431010],
    [13900.00, 13911.99, 347.65, 8845529314],
    [13912.00, 13923.99, 347.95, 8845627618],
    [13924.00, 13935.99, 348.25, 8845758690],
    [13936.00, 13947.99, 348.55, 8845856994],
    [13948.00, 13959.99, 348.85, 8846020834],
    [13960.00, 13971.99, 349.15, 8846119138],
    [13972.00, 13983.99, 349.45, 8846217442],
    [13984.00, 13995.99, 349.75, 8846250210],
    [13996.00, 14007.99, 350.05, 8846282978],
    [14008.00, 14019.99, 350.35, 8846315746],
    [14020.00, 14031.99, 350.65, 8846348514],
    [14032.00, 14043.99, 350.95, 8846381282],
    [14044.00, 14055.99, 351.25, 8846414050],
    [14056.00, 14067.99, 351.55, 8846446818],
    [14068.00, 14079.99, 351.85, 8846479586],
    [14080.00, 14091.99, 352.15, 8846512354],
    [14092.00, 14103.99, 352.45, 8846545122],
    [14104.00, 14115.99, 352.75, 8846577890],
    [14116.00, 14127.99, 353.05, 8846610658],
    [14128.00, 14139.99, 353.35, 8846774498],
    [14140.00, 14151.99, 353.65, 8846807266],
    [14152.00, 14163.99, 353.95, 8846938338],
    [14164.00, 14175.99, 354.25, 8846971106],
    [14176.00, 14187.99, 354.55, 8847003874],
    [14188.00, 14199.99, 354.85, 8847036642],
    [14200.00, 14211.99, 355.15, 8847069410],
    [14212.00, 14223.99, 355.45, 8847102178],
    [14224.00, 14235.99, 355.75, 8847134946],
    [14236.00, 14247.99, 356.05, 8847167714],
    [14248.00, 14259.99, 356.35, 8847200482],
    [14260.00, 14271.99, 356.65, 8847233250],
    [14272.00, 14283.99, 356.95, 8847266018],
    [14284.00, 14295.99, 357.25, 8847298786],
    [14296.00, 14307.99, 357.55, 8847331554],
    [14308.00, 14319.99, 357.85, 8847364322],
    [14320.00, 14331.99, 358.15, 8847397090],
    [14332.00, 14343.99, 358.45, 8847429858],
    [14344.00, 14355.99, 358.75, 8847462626],
  ];

  for (var i = 0; i < data.length; i++) {
      var item = data[i];
      result.push({
          min: item[0].toFixed(2),
          max: item[1].toFixed(2),
          price: item[2].toFixed(2),
          id: 47640000000000 + item[3] 
      });
  }
  return result;
})();



var isProcessingRemoval = false;

/* --- 检测并删除 (局部刷新) --- */
function checkAndRemoveProtection() {
  if (window.location.pathname !== '/cart' || isProcessingRemoval) return;

  const cart = window.hm_shop && window.hm_shop.cart;
  if (!cart || !cart.items) return;

  const hasProtection = cart.items.some(item => 
    shipProtections.some(sp => sp.id === item.id) || item.product_type === 'Ship Protection'
  );

  if (hasProtection) {
    const cartRows = document.querySelectorAll('[data-line-item], .cart-item, .cart__item, .cart-row');
    cartRows.forEach(row => {
      if (row.innerText.includes('Ship Protection') || row.innerHTML.includes('Ship Protection')) {
        const removeBtn = row.querySelector('a[href*="quantity=0"], .cart-item__remove, [data-remove-item], .remove');
        if (removeBtn) {
          isProcessingRemoval = true;
          row.style.opacity = '0';
          removeBtn.click(); // 触发原生 Ajax 局部刷新
          setTimeout(() => { isProcessingRemoval = false; }, 3000);
        }
      }
    });
  }
}

/* --- UI 隐藏 --- */
function hideShipProtectionUI() {
  document.querySelectorAll('[data-line-item], .cart-item, .cart__item, .cart-row').forEach(el => {
    if (el.innerText.includes('Ship Protection')) el.style.display = 'none';
  });
}


/* --- 动态获取价格并更新按钮 UI --- */
// function refreshCheckoutButtonPrice() {
//   fetch('/cart.js')
//     .then(res => res.json())
//     .then(cart => {
//       const subtotal = cart.items_subtotal_price;
//       let targetPrice = null;

//       // 匹配对应的运费险价格
//       for (let sp of shipProtections) {
//         const min = Math.round(parseFloat(sp.min) * 100);
//         const max = Math.round(parseFloat(sp.max) * 100);
//         if (subtotal >= min && subtotal <= max) {
//           targetPrice = sp.price;
//           break;
//         }
//       }

//       if (!targetPrice) return;

//       // 使用 querySelectorAll 确保同时覆盖 PC 和 手机端
//       // 并且增加对 class 的模糊匹配，以防手机端没用 id
//       const btns = document.querySelectorAll('[id*="checkout-with-shipping"], .checkout-with-shipping');
      
//       btns.forEach(btn => {
//         if (!btn.dataset.originalText) {
//           // 正则处理：去掉任何括号及其内容
//           btn.dataset.originalText = btn.innerText.replace(/\s*\(.*\)/, '').trim();
//         }
//         btn.innerText = `${btn.dataset.originalText} (+$${targetPrice})`;
//       });


//       // 更新shipping-protection右上角的金额
//       const priceDisplays = document.querySelectorAll('.ship-protection-price-display');
//       priceDisplays.forEach(el => {
//         el.innerText = formattedPrice;
//       });

//     })
//     .catch(err => console.error("Failed to fetch cart:", err));
// }

function refreshCheckoutButtonPrice() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const subtotal = cart.items_subtotal_price;
      let targetPrice = null;

      // 1. 匹配对应的运费险价格
      for (let sp of shipProtections) {
        const min = Math.round(parseFloat(sp.min) * 100);
        const max = Math.round(parseFloat(sp.max) * 100);
        if (subtotal >= min && subtotal <= max) {
          targetPrice = sp.price;
          break;
        }
      }

      if (!targetPrice) return;

      // 定义要显示的金额格式
      const displayAmount = `$${targetPrice}`;

      // 2. 更新结账按钮
      const btns = document.querySelectorAll('[id*="checkout-with-shipping"], .checkout-with-shipping');
      btns.forEach(btn => {
        if (!btn.dataset.originalText) {
          // 正则优化：不仅去掉括号，还去掉可能已经存在的 +$ 符号，防止重复
          btn.dataset.originalText = btn.innerText.replace(/\s*\(.*\)/, '').replace(/\s*\+\s*\$.*/, '').trim();
        }
        btn.innerText = `${btn.dataset.originalText} (+${displayAmount})`;
      });

      // 3. 更新 shipping-protection 右上角的金额
      const priceDisplays = document.querySelectorAll('.ship-protection-price-display');
      priceDisplays.forEach(el => {
        el.innerText = displayAmount; 
      });

    })
    .catch(err => console.error("Failed to fetch cart:", err));
}




/* 初始化 */
(function init() {
  if (window.location.pathname !== '/cart') return;

  // 立即执行一次
  refreshCheckoutButtonPrice();

  // 监听 DOM 变化
  let updateTimer;
  const observer = new MutationObserver((mutations) => {
    // 检查是否有新节点加入，或者按钮文本被主题自带脚本改回去了
    hideShipProtectionUI();
    checkAndRemoveProtection();
    
    clearTimeout(updateTimer);
    updateTimer = setTimeout(refreshCheckoutButtonPrice, 300);
  });
  
  observer.observe(document.body, { 
    childList: true, 
    subtree: true,
    characterData: false // 避免监听文本改变导致死循环
  });
})();


/* ===============================
   Global Checkout Click Listener
   PC + Mobile Safe
================================ */

document.addEventListener('click', function (e) {

  const btn = e.target.closest(
    '[id*="checkout-with-shipping"], [id*="checkout-without-shipping"]'
  );

  if (!btn) return;

  e.preventDefault();

  const isWithShipping =
    btn.id.includes('checkout-with-shipping') &&
    !btn.id.includes('without');

  const cart = window.hm_shop && window.hm_shop.cart;
  if (!cart) {
    window.location.href = '/checkout';
    return;
  }

  /* ========== 防止重复点击 ========== */
  if (btn.dataset.processing === '1') return;
  btn.dataset.processing = '1';
  btn.disabled = true;
  btn.innerText = 'Processing...';

  /* ========== 找到已有运费险 ========== */
  const protections = cart.items.filter(i =>
    i.product_type === 'Ship Protection' ||
    shipProtections.some(sp => sp.id === i.id)
  );

  /* ========== 不带运费险结账 ========== */
  if (!isWithShipping) {

    if (protections.length === 0) {
      window.location.href = '/checkout';
      return;
    }

    let updates = {};
    protections.forEach(i => updates[i.key] = 0);

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    }).finally(() => {
      window.location.href = '/checkout';
    });

    return;
  }

  /* ========== 带运费险结账 ========== */
  const subtotal = cart.items_subtotal_price;
  let targetId = null;

  for (let sp of shipProtections) {
    const min = Math.round(parseFloat(sp.min) * 100);
    const max = Math.round(parseFloat(sp.max) * 100);
    if (subtotal >= min && subtotal <= max) {
      targetId = sp.id;
      break;
    }
  }

  if (!targetId) {
    window.location.href = '/checkout';
    return;
  }

  let updates = {};
  protections.forEach(i => updates[i.key] = 0);

  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates })
  })
  .then(() => {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: targetId, quantity: 1 }]
      })
    });
  })
  .finally(() => {
    window.location.href = '/checkout';
  });

}, true);